import { Component, OnInit, Inject, ChangeDetectorRef, NgZone } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { validationmethod } from "src/app/shared/common/validationmethod";
import { TrnxCommonTs } from "src/app/shared/common/trnxCommonTs";
import { UntypedFormGroup, UntypedFormControl, Validators } from "@angular/forms";
import { constants } from "src/app/shared/common/contants";
import { CommonService } from "src/app/shared/services/common.service";
import * as moment from "moment";
import { DomSanitizer } from '@angular/platform-browser';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { LoginService } from 'src/app/shared/services/login.service';
import { CronJobIntervalComponent } from '../cron-job-interval/cron-job-interval.component';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import { TrnxCommonService } from 'src/app/shared/services/trnx-common.service';
import { CreateAttributesScreenComponent } from '../create-attributes-screen/create-attributes-screen.component';
import { ReportingServiceService } from 'src/app/shared/services/reporting-service.service';
import { ManagemdlscriptComponent } from '../managemdlscript/managemdlscript.component';
import { ManagemdlscriptpopupComponent } from '../managemdlscript/managemdlscriptpopup/managemdlscriptpopup.component';
import { MultiselectmdlscriptComponent } from '../managemdlscript/multiselectmdlscript/multiselectmdlscript.component';
import { AfterViewInit } from '@angular/core';


export interface FormData {
  ngModelObjectDivision: any;
  ngModelObject: any; 
  tableName: any;
  dynamicData: any;
  retrieveObject: any;
  buttonName: any;
  listObjectDropDown: any;
  bootstrapColumn: any;
  tableID: any;
  headerNameHtml: any;
  trnxScreenId: any;
  update: any;
  screenTypeTOrM: any;
  childKey: any;
  masterTableId: any;
  refreshHistory:any;
  selectedObjectDns:any;
  // repositoryType: 'CUSTOM' | 'STANDARD';  
  pageLayouts: any[];                     
  layoutAttributeMap: Map<string, any[]>; 
  
 
}
@Component({
    selector: 'app-trnx-base-popup-screen',
    templateUrl: './trnx-base-popup-screen.component.html',
    styleUrls: ['./trnx-base-popup-screen.component.scss'],
    standalone: false
})
export class TrnxBasePopupScreenComponent implements OnInit {
  selectedPageLayout: any = null;
selectedSection: string = '';
availableSections: string[] = [];
availableFields: string[] = [];
layoutAttributeMap: Map<string, any[]> = new Map();

  formValid: UntypedFormGroup;

  formChildValid: UntypedFormGroup;

  ngModelObjectDivision = [];

  temporaryChildObject = [];

  ngModelObject = [];

  ngModelChildObject = [];

  eachDetailsData: any = [];

  bindingDetailsData: any = [];

  tableName = "";

  headerNameHtml = "";

  trnxScreenId;

  dynamicData = [];

  childDynamicData = [];

  retrieveObject: any = [];

  buttonName;

  buttonNameClose;

  hide = false;

  nextButton = true;

  updateButton = false;

  parentUpdate;
  childUpdate;

  eyeIcon = true;

  listObjectDropDown: any = [];

  listChildObjectDropDown: any = [];

  listObjectDropDownDuplicate: any = [];

  bootstrapColumn = 0;

  detailsDataCount = 0;

  allocateButtonsBoolean = false;

  allocateButtons1Boolean = false;

  closeIconButtonBoolean = false;

  closeIconButton1Boolean = false;

  ngModelChildObjectDivision = []

  tableID = "";
  keyValues="";

  detailValue = "";

  numberOfChildrenDropDowns = 0;

  childrenDropDownsIncrement = 0;

  parentScreen = true;
  childScreen = false;

  screenTypeTOrM = "";

  nextSaveTOrM = "";

  childKey;

  masterTableId = "";

  formValidCheckbox: UntypedFormGroup;

  isCheckboxSelected: boolean = false;

  backgroundColorButton = "";
  refreshHistory:any;
  systemName ="";
  companyId:any = "";
  externalObjectFile :any;
  externalObjectFileName=false;
  attributeJsonFromFile=[];
  readonlyObjectName=false;
  selectedObjectDns;
    isSelected:boolean = false;
    scriptype:any;

    sourceDNSId;
    listOfSourceDNS:any=[]
    listOfObjectsWithGroup:any=[]
      tooltipMessage: String = '';
    isJtestWorkspace:boolean=false;
  systemnameForVaultAuthtype: any;
  showAuthName = false

 repositoryType: 'Custom' | 'Standard' | null = null;
pageLayoutList: any[] = [];





  constructor(private dialogref: MatDialogRef<TrnxBasePopupScreenComponent>,

    @Inject(MAT_DIALOG_DATA) public data: FormData,
    
    private validation: validationmethod,
    private trnxCommonTs: TrnxCommonTs,
    private localStorageSettings: LocalStorageSettingsService,
    private constants: constants,
    private service: CommonService,
    private snackBar: MatSnackBar,
    private sanitizer: DomSanitizer,
    private auth: LoginService,
    private dialog: MatDialog,
    private spinner: NgxUiLoaderService,
    private snackbar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    private loginService: LoginService,
    private trnxCommonservice: TrnxCommonService,
    private ngZone: NgZone,
    private reportService: ReportingServiceService
  ) {

  }

  ngOnInit() {
 
        this.tooltipMessage='If documents are included, upload a ZIP; otherwise, upload the Excel file only.';

   this.showAuthName = false;

    this.formValidationsCheckbox();

    console.log(this.data);

   if(this.data.selectedObjectDns != undefined && this.data.selectedObjectDns != null ){
    this.selectedObjectDns=this.data.selectedObjectDns.replace(/^Source_/, '').replace(/^Target_/, '')
    console.log(this.selectedObjectDns)
   }

      if(this.data.buttonName=="Update" && this.data.headerNameHtml === "Source Data Extraction Queries"){
    console.log("&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&");
    //  && ngModelTemporary.fieldName == "objectgroupid" && ngModelTemporary.fieldType == "Select List - Static"
      this.getObjectsOnObjectName();
    }


    if (this.data.headerNameHtml == "Objects" && this.data.buttonName == "Update") {
      for(let a=0;a<this.data.ngModelObject.length;a++){
        console.log(this.data.ngModelObject[a])
        if (this.data.ngModelObject[a].formName === "Object Type") {
          console.log(this.data.ngModelObject[a]);
          console.log(this.data.listObjectDropDown[0][this.data.ngModelObject[a].dropDownIndex].lookupvalue)
          if ((this.data.listObjectDropDown[0][this.data.ngModelObject[a].dropDownIndex].lookupvalue) == "External Objects") {
            this.readonlyObjectName = true;
          }
        //  this.externalObjectFileName=true;
          console.log(this.externalObjectFileName);
          this.listObjectDropDown = this.data.listObjectDropDown;
          console.log(this.data.ngModelObjectDivision[2][0].value)
         // this.data.ngModelObjectDivision[2][0].value="External Objects";
         // console.log(this.data.ngModelObjectDivision[2][0].value)
          console.log(this.data)


        }
          
       }

       for(let j=0;j<this.data.ngModelObjectDivision[2].length;j++){

       }

     }
  
    this.tableName = this.data.tableName;

    this.ngModelObjectDivision = this.data.ngModelObjectDivision;
    for (let i = 0; i < this.ngModelObjectDivision.length; i++) {
      console.log(this.ngModelObjectDivision[i])
      

      for(let a=0;a<this.ngModelObjectDivision[i].length;a++){
        
        if(this.ngModelObjectDivision[i][a].value == "External Objects" ){
          if(this.data.buttonName == "Update"){
            this.ngModelObjectDivision[i][a].keyValue = "External Objects";
            console.log(this.ngModelObjectDivision[i][a])
          }else{
            this.ngModelObjectDivision[i][a].value="";
            console.log(this.ngModelObjectDivision[i])
          }
       
      }

      }
      if(this.data.buttonName ==="Update"){
        console.log(this.ngModelObjectDivision[i])
        if(this.ngModelObjectDivision[i].length>=1){
          let fieldName = this.ngModelObjectDivision[i][0].fieldName;
          if(this.tableName==="vaultconfigmstr" && fieldName === "systemname" ){
           let lookupid = this.ngModelObjectDivision[i][0].keyValue
          this.loginService.getSystemNamebyid(lookupid).subscribe(resp=>{
            console.log(resp);  
            if(resp['data'].toLowerCase()==="vault"){
              this.systemName = "Vault";
              this.showAuthName = true;
              this.setAuthNameMandatory(true);
              this.cdr.detectChanges();
            }else{
               this.showAuthName = false;
               this.setAuthNameMandatory(false);
            }
          })
        
          }
          
        }

      
        
    


       
      }
      if(this.tableName==="vaultconfigmstr" && this.ngModelObjectDivision[i].fieldName === "sessionexpirationtime" ){
        this.ngModelObjectDivision[i].keyValue = 0;    
      }

    }
          this.headerNameHtml = this.data.headerNameHtml;
          this.ngModelObject = this.data.ngModelObject;
         
 
              if (this.headerNameHtml === 'Screen Element Repository' && this.data.buttonName === 'Update') {
        // Wait for listObjectDropDown to be populated
        setTimeout(() => {
          this.initializeRepositoryTypeForEdit();
        }, 300);
      }


 
    const overwriteField = this.ngModelObject.find(
  o => o.keyName === 'overwrite_mode'
);
 
if (overwriteField) {
  if (overwriteField.keyValue === 'true' || overwriteField.keyValue === true) {
    overwriteField.keyValue = 'Yes';
  } else if (overwriteField.keyValue === 'false' || overwriteField.keyValue === false) {
    overwriteField.keyValue = 'No';
  }
}
    console.log(this.data);

   
    console.log(this.tableName)

    this.trnxScreenId = this.data.trnxScreenId;

    console.log(this.trnxScreenId)

    

    this.dynamicData = this.data.dynamicData;

    console.log(this.dynamicData)

    this.retrieveObject = this.data.retrieveObject;

    this.buttonName = this.data.buttonName;

    console.log(this.buttonName);
    console.log(this.data.listObjectDropDown)

    this.listObjectDropDown = this.data.listObjectDropDown;
    setTimeout(() => {
    if (
    this.headerNameHtml === 'Screen Element Repository' &&
    this.data.buttonName === 'Save'
  ) {
    this.setDefaultRepositoryTypeStandard();
  }
});


    this.data.listObjectDropDown.forEach(listObjectDropDownTemp => {

      let listTemporary: any = [];

      listObjectDropDownTemp.forEach(listObjectDropDownTemporary => {

        listTemporary.push(Object.assign({}, listObjectDropDownTemporary));

      }
      );
     console.log(listTemporary);

      this.listObjectDropDownDuplicate.push(listTemporary);
      if (
  this.headerNameHtml === 'Screen Element Repository' &&
  this.data.buttonName === 'Save'
) {
  setTimeout(() => {
    this.setDefaultRepositoryTypeStandard();
  });
}


    });

    // Store original values for comparison
if (this.data.buttonName === 'Update') {
  const pageField = this.ngModelObject.find(f =>
    f.fieldName?.toLowerCase().includes('page')
  );
  if (pageField) {
    pageField.originalValue = pageField.keyValue; 
  }
  
  const sectionField = this.ngModelObject.find(f =>
    f.fieldName?.toLowerCase().includes('section')
  );
  if (sectionField) {
    sectionField.originalValue = sectionField.keyValue;
  }
}
    console.log(this.listObjectDropDown);

    let dropDownChildFieldNameArray = [];

    let keyNames = [];


    let indexArray = [];

    this.tableID = this.data.tableID;
    



    this.ngModelObject.forEach(ngModelObjectTemp => {
     
      if (ngModelObjectTemp.dropDownChildFieldName != undefined) {

        //Getting children dropdown names
        console.log(ngModelObjectTemp.dropDownChildFieldName);
        // console.log("+++++++++++++++++++++++++++++++++++++++++")
        dropDownChildFieldNameArray.push(ngModelObjectTemp.dropDownChildFieldName);
       
    }
       if(this.headerNameHtml == "Import Export MetaData"){
          console.log(ngModelObjectTemp);
          if(ngModelObjectTemp.keyName == "importType"){
            console.log(ngModelObjectTemp);
            ngModelObjectTemp.keyValue = parseInt(ngModelObjectTemp.keyValue)
            console.log(ngModelObjectTemp);
            

          }
        }
        
      //Storing keyNames
      keyNames.push(ngModelObjectTemp.keyName);
      if(this.tableID === ngModelObjectTemp.keyName){
        this.keyValues = ngModelObjectTemp.keyValue;
        console.log(this.keyValues)
      }

      //Storing dropdown index
      indexArray.push(ngModelObjectTemp.dropDownIndex);

    });

    console.log(dropDownChildFieldNameArray);

    this.numberOfChildrenDropDowns = dropDownChildFieldNameArray.length;

    console.log(keyNames);

    console.log(indexArray);

    dropDownChildFieldNameArray.forEach(dropDownChildFieldNameArrayTemp => {

      //Getting index of dropDownChildFieldNameArrayTemp
      let index = keyNames.indexOf(dropDownChildFieldNameArrayTemp);

      //Getting child dropDown index
      let DchildDropDownIndex = indexArray[index];

      

      //Doing empty array to listObjectDropDown at childDropDownIndex
           /**
                 * Author-Asha Waghadure
                 * Date:01-07-2025
                 * commented code because getting empty dropdownlist
                 */
           // this.listObjectDropDown[childDropDownIndex] = [];
    });

    if (this.buttonName == "Save") {

      this.buttonNameClose = "Save";

    }

    else {

      this.buttonNameClose = "Update";

      this.hide = false;

      this.eyeIcon = false;
      if (this.data.update == "parentTrue") {
        this.nextButton = false;
        this.updateButton = true;
        this.parentUpdate = "true";
      } else {
        this.nextButton = false;
        this.updateButton = true;
        this.parentUpdate = "false";
      }


    }

    this.childKey = this.data.childKey;

    //It is storing transaction master primary key name.
    this.masterTableId = this.data.masterTableId;

    this.bootstrapColumn = this.data.bootstrapColumn;

    console.log(this.data.screenTypeTOrM);

    this.screenTypeTOrM = this.data.screenTypeTOrM;

    if (this.bootstrapColumn == 1) {

      this.allocateButtons1Boolean = true;

      this.closeIconButton1Boolean = true;

    }

    else {

      this.allocateButtonsBoolean = true;

      this.closeIconButtonBoolean = true;

    }

    console.log(this.screenTypeTOrM);

    //To different master and transaction screens.
    if (this.screenTypeTOrM == "Transaction") {

      this.nextSaveTOrM = "Next";

    }

    else {

      this.nextSaveTOrM = "Save";

    }

    if(this.tableName==="vaultconfigmstr"){
      this.dynamicData.forEach(e =>{
        if(e.fieldName ==="sessionexpirationtime"){
          e.mandatory = false;
         }
         else if(e.fieldName ==="vaultversion") {
          e.mandatory = false;
         }
         else if(e.fieldName ==="burstlimitthreshold") {
          e.mandatory = false;
         }
         else if(e.fieldName ==="burstlimitsleeptime") {
          e.mandatory = false;
         }
      })
    }

    /**
     * ModifiedBy-Asha Waghadure
     * Date-18-07-2025
     * added for managetestscriptsmstr to display Action File based on script type
     */
      // if(this.tableName==="managetestscriptsmstr"){
      //   if(this.data.buttonName=="Update"){
      //       const scriptTypeField = this.data.ngModelObject.find(e => e.fieldName === 'scripttype');
      //       console.log(scriptTypeField); 
      //       let lookupvalueid = Number(scriptTypeField.keyValue);
      //       const dropdownList = this.listObjectDropDown[scriptTypeField.dropDownIndex];
      //       console.log(dropdownList)
      //       const match = dropdownList.find((item: any) => item.lookupvalueid === lookupvalueid);
      //       console.log(match)
      //       if(match !==undefined){
      //       this.scriptype=match.lookupvalue;

      //      if (this.scriptype=="Record Validation") {
      //             this.isSelected=true
      //       }else if(this.scriptype=="Record Creation"){
      //             this.isSelected=false
      //       }
      //       console.log(this.isSelected)
      //       this.displayActionFileBasedOnScriptType(this.isSelected)
      //     }else{
      //        this.displayAllFieldsManageTestScriptScreen();
      //     }
      //    }
      //    else{
      //      this.displayAllFieldsManageTestScriptScreen();
      //   }
      // }
      if(this.tableName==="tenantmanagementmstr"){
        if(this.data.buttonName=="Update"){
            const scriptTypeField = this.data.ngModelObject.find(e => e.fieldName === 'jtestworkspace');
            console.log(scriptTypeField); 
            let jtestworkspace = scriptTypeField.keyValue;
            
            console.log(jtestworkspace)
            console.log(this.isSelected)
        
            this.displayFieldsBasedOnJtestWorkspace(jtestworkspace)
          
         }
         else{
           this.displayAllFieldsBasedOnJtestWorkspace();
        }
      }
    /**
     * ModifiedBy-Asha Waghadure
     * Date-01-07-2025
     * adding keyValue to dynamicdata

     */
     this.dynamicData.forEach(dynamic => {
        const matchingModel = this.ngModelObject.find(model => model.keyName === dynamic.fieldName);
      if (matchingModel) {
      dynamic.keyValue = matchingModel.keyValue;
      }
     });
    // form validations
    this.formValidations();

    this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");

    console.log(this.backgroundColorButton);


    console.log(this.ngModelObject);

console.log(this.listObjectDropDown);

  }



async getObjectsOnObjectName(){
    this.spinner.start()
    let objectGroupName=""
  for (let j = 0; j <this.data.retrieveObject.length; j++) {
        if (this.data.retrieveObject[j].sqlscriptid__j === this.data.ngModelObject[0].keyValue) {
          objectGroupName=this.data.retrieveObject[j].objectgroupid1;
          break;
        }
  }
    let dnsId = this.localStorageSettings.getSettings("dnsName");
   
   let workspaceid = this.localStorageSettings.getSettings('WorkspaceId');

    this.reportService.retrieveSourceDNSByWorkspaceId(workspaceid).subscribe((res:any)=>{
      if(res == undefined || res == null){
        this.snackbar.open("Source DNS not found. Please configure atleast one dns as source to continue.", "OK", {duration: 5000});
      } else{
        console.log(res);
        this.listOfSourceDNS=res
         if (this.listOfSourceDNS && this.listOfSourceDNS.length > 0) {
          this.sourceDNSId =this.listOfSourceDNS[0].vaultConfigMstrId;
          this.service.getObjectsWithObjectGroup(dnsId,objectGroupName,this.sourceDNSId).subscribe((res:any)=>{
              console.log(res);
              if(res.error == true){
                        // this.spinner.stop();
                        this.listOfObjectsWithGroup=[]
                        this.snackbar.open(res.statusMessage, "OK", {
                          duration: 5000,
                        });
                      }else{
                        this.listOfObjectsWithGroup=res
                      }
              console.log(this.listOfObjectsWithGroup);
              this.cdr.detectChanges();
              this.spinner.stop();
            })
         }
      }
    })
  
  }

  formValidations() {
        this.formValid = this.trnxCommonTs.formValidations(this.dynamicData);

    console.log("+++++++++++++++++++++++++++++++++++++++++++++");

    console.log(this.formValid);
    const jtestworkspace = this.formValid.get('jtestworkspace');
    
      this.applyEmailUsernameLogic();
      /**
       * @Author-Asha Waghadure
       * @Date-13-12-2025
       * Added for jtestworkspace checkbox of Manage Workspace screen
       */
      
      jtestworkspace?.valueChanges.subscribe((checked: boolean) => {
       if (checked) {
        this.displayFieldsBasedOnJtestWorkspace(checked)

       }
       else{
        this.displayFieldsBasedOnJtestWorkspace(checked)
        
       }
      }
       );

  }

  childFormValidations() {
    this.formChildValid = this.trnxCommonTs.childFormValidations(this.childDynamicData);
  }

  radiochange(e) {
    console.log(e.value)

  }

  childRadiochange(e) {
    console.log(e.value)
  }

  //Insert or update data to the server.
  /*async sendData() {

    let isExecute: any = 0;

    console.log(this.ngModelObject);

    isExecute = this.trnxCommonTs.checkingCombinationColumnsUnique(this.ngModelObject, this.retrieveObject, isExecute);

    console.log(isExecute);

    let temporaryObject: any = [];

    temporaryObject = this.trnxCommonTs.ngModelData(this.ngModelObject);

    if (this.buttonName == this.constants.btnname) {

      // checking the form is valid or not while insert
      if (!this.formValid.valid) {

        // displaying validation messages

        this.validation.validateAllFormFields(this.formValid);

        this.validation.getvalidationmessage();

      }

      else {

        await this.trnxCommonTs.insertTrnxData(temporaryObject, this.tableName, isExecute, this.ngModelObject, this.tableID, this.temporaryChildObject, this.screenTypeTOrM, this.childKey, this.masterTableId);

        this.reset();

      }

    }

    else {

      // checking the form is valid or not while update
      if (!this.formValid.valid) {

        // displaying validation messages
        this.validation.validateAllFormFields(this.formValid);

        this.validation.getvalidationmessage();

      }

      else {

        await this.trnxCommonTs.updateTrnxData(temporaryObject, this.tableName, isExecute, this.ngModelObject, this.tableID);

        this.reset();

      }

    }

  }*/

  reset() {

    this.ngModelObject.forEach(inputObject => {

      inputObject.keyValue = "";

      inputObject.imageShow = false;

      inputObject.imageshow1 = false;

      inputObject.fileShow = false;

      inputObject.startDateValue = moment(null);

      inputObject.endDateValue = moment(null);

      inputObject.startDateTimeValue = moment(null);

      inputObject.endDateTimeValue = moment(null);

      inputObject.binaryFormat = false;

      inputObject.downloadIconShow = false;

    });



    console.log(this.ngModelObject);

    this.formValid.reset();

    this.formValidations();

    this.ngModelObject.forEach(inputObject => {

      if (inputObject.fieldType == "DatePicker" && inputObject.maximumDate != undefined) {

        inputObject.endDateValue = inputObject.maximumDate;

        console.log(inputObject.endDateValue);

      }

      if (inputObject.fieldType == "DateTimePicker" && inputObject.maximumDateTime != undefined) {

        inputObject.endDateTimeValue = inputObject.maximumDateTime;

        console.log(inputObject.endDateTimeValue);

      }

    });

    this.buttonName = this.constants.btnname;

    this.buttonNameClose = "Save";

    this.eyeIcon = true;

  }

  resetChildData() {

    this.formChildValid.reset();
    this.ngModelChildObject.forEach(inputChildObject => {

      inputChildObject.keyValue = "";

      inputChildObject.imageShow = false;

      inputChildObject.imageshow1 = false;

      inputChildObject.fileShow = false;

      inputChildObject.startDateValue = moment(null);

      inputChildObject.endDateValue = moment(null);

      inputChildObject.startDateTimeValue = moment(null);

      inputChildObject.endDateTimeValue = moment(null);

      inputChildObject.binaryFormat = false;

      inputChildObject.downloadIconShow = false;

    });
    this.ngModelChildObject.forEach(inputObject => {

      if (inputObject.fieldType == "DatePicker" && inputObject.maximumDate != undefined) {

        inputObject.endDateValue = inputObject.maximumDate;

        console.log(inputObject.endDateValue);

      }

      if (inputObject.fieldType == "DateTimePicker" && inputObject.maximumDateTime != undefined) {

        inputObject.endDateTimeValue = inputObject.maximumDateTime;

        console.log(inputObject.endDateTimeValue);

      }

    });
  }

  resetChild() {
    this.childFormValidations();
    this.formChildValid.reset();
    this.ngModelChildObject.forEach(inputChildObject => {

      inputChildObject.keyValue = "";

      inputChildObject.imageShow = false;

      inputChildObject.imageshow1 = false;

      inputChildObject.fileShow = false;

      inputChildObject.startDateValue = moment(null);

      inputChildObject.endDateValue = moment(null);

      inputChildObject.startDateTimeValue = moment(null);

      inputChildObject.endDateTimeValue = moment(null);

      inputChildObject.binaryFormat = false;

      inputChildObject.downloadIconShow = false;

    });
    this.ngModelChildObject.forEach(inputObject => {

      if (inputObject.fieldType == "DatePicker" && inputObject.maximumDate != undefined) {

        inputObject.endDateValue = inputObject.maximumDate;

        console.log(inputObject.endDateValue);

      }

      if (inputObject.fieldType == "DateTimePicker" && inputObject.maximumDateTime != undefined) {

        inputObject.endDateTimeValue = inputObject.maximumDateTime;

        console.log(inputObject.endDateTimeValue);

      }

    });

  }

  // event on input type file
  imageFunction($event, ngModelTemporary): void {

    console.log($event);

    console.log(ngModelTemporary);

    this.readThisimage($event.target, ngModelTemporary);

  }
  imageChildFunction($event, ngModelChildTemporary): void {

    console.log($event);

    console.log(ngModelChildTemporary);

    this.readThisChildimage($event.target, ngModelChildTemporary);

  }

  // to encode the selected photo
  readThisimage(inputValue: any, ngModelTemporary): void {

    console.log(inputValue);

    console.log(ngModelTemporary);

    this.trnxCommonTs.readThisImage(inputValue, ngModelTemporary, this.ngModelObject, this.formValid);

  }

  // to encode the selected photo
  readThisChildimage(inputValue: any, ngModelChildTemporary): void {

    console.log(inputValue);

    console.log(ngModelChildTemporary);

    this.trnxCommonTs.readThisChildImage(inputValue, ngModelChildTemporary, this.ngModelChildObject, this.formChildValid);

  }

  openImage(image) {

    this.trnxCommonTs.openImage(image);

  }

  //delete attachements
  deleteImage(ngModelTemporary) {

    console.log(ngModelTemporary);

    this.trnxCommonTs.trnxDeleteImage(ngModelTemporary, this.formValid, this.ngModelObject);

  }

  deleteChildImage(ngModelTemporary) {

    this.trnxCommonTs.trnxDeleteImage(ngModelTemporary, this.formChildValid, this.ngModelChildObject);

  }

  close() {
    if (this.parentUpdate == "true") {
      this.reset();
    } else if (this.parentUpdate == "false") {
      this.resetChild();
    } else {
      this.reset();
      this.resetChild();
    }

    console.log(this.isCheckboxSelected);

    console.log(typeof this.isCheckboxSelected);

    //It will execute if checkbox is not selected.
    if (this.isCheckboxSelected == false) {

      //It will reset checkbox form.
      this.formValidCheckbox.reset();

      //It will call checkbox formValidationCheckbox method.
      this.formValidationsCheckbox();

      this.data.listObjectDropDown = [];

      this.temporaryChildObject = [];

      this.listObjectDropDownDuplicate.forEach(listObjectTemp => {

        this.data.listObjectDropDown.push(listObjectTemp);

      });

      console.log(this.data.listObjectDropDown);

      console.log(this.listObjectDropDownDuplicate);

      this.dialogref.close(this.data.listObjectDropDown);

    }

  }


 

  //Insert or update data to the server.
  async sendDataAndClose() {

    this.syncRepositoryTypeToNgModel();
    if (this.tableName === 's3paths') {
      const s3PathValue = this.formValid.controls['s3pathname']?.value;
      // Regex — allows only letters, numbers, underscores, dashes, and slashes
      const validPattern = /^[A-Za-z0-9_\-\/]+$/;
      if (s3PathValue && !validPattern.test(s3PathValue)) {
        this.snackbar.open(
          'Special characters are not allowed in S3 Path Name.',
          'Close',
          {
            duration: 4000,
            panelClass: ['error-snackbar'] // optional custom class
          }
        );
        return; // Stop further processing
      }
    }


    /**
   * Modified By-Renuka chama
   * Date-24-12-2025
   * added special characters validation message
   */

   const specialCharRestrictedTables = {
  'managetestscriptsmstr': ['scriptname'],
  'modulemstr' : ['modulename','modulecode'],
  'objectrepositorymstr' : ['objectname', 'pagename','section','subsection'],
  'submodulemstr' : ['submodulename', 'submodulecode'],
  'testcyclemstr' : ['cyclename'],
  'emrconfigurationmstr' : ['eckeyname','ecsubnetid','jobflowrole','servicerole','releaselabel','numexecutors','executorcores','executormemory','drivermemory','masterinstancetype','slaveinstancetype','securityConfigName'],
  'lookuptype' :['lookuptype'],
  'objectmetadata':['objectlabel','objectname','parentobjectlabel'],
  'company' : ['compname','compnorcode','contactperson','contactphonenumber'],
  'vaultconfigmstr' : ['dnsname','databasename','datasourceregion','noofsets','deferredsets','s3bucketname'],
  'jsuiteversionmanagementmstr' :['jsuiteversion','accesstoken'],
  'tenantmanagementmstr' :['tenantname','databasename','bucketname'],
  'users' :['firstname','lastname','phonenumber','empno'],
  'userrolesmstr':['rolename'],
  'ftpconnectionmstr' :['ftphostname','ftpusername'],
  'jsuitepropertiesmstr' :['propertyname'],
  'loadobjectsmstr' :['objectname','objecttype','fileName','loadaction','parentobjectnameforextraction','objectgroupname'],
  'sqlscripts__j' :['filename__j','queryexecutiontype__j','sourcetype__j']
};

const uiFieldNames: Record<string, string> = {
  'compname': 'Company Name','compnorcode': 'Company Code','contactperson': 'Contact Person','contactphonenumber': 'Phone Number',
  'scriptname': 'Script Name', 'modulename': 'Module Name','modulecode': 'Module Code',
  'objectname' : 'Object Name' , 'pagename': 'Page Name','section':'Section','subsection':'Sub Section',
  'submodulename' : 'Sub Module Name', 'submodulecode' : 'Sub Module Code' , 'cyclename': 'Cycle Name', 
  'eckeyname': 'EC2 Key Name','ecsubnetid' : 'EC2 Subnet Id','jobflowrole': 'Job Flow Role','servicerole': 'Service Role',
  'releaselabel': 'Release Label','numexecutors':'Num-Executors','executorcores':'Executor-Cores','executormemory':'Executor-Memory',
  'drivermemory':'Driver-Memory','masterinstancetype':'Master Instance Type','slaveinstancetype':'Slave Instance Type','securityConfigName':'Security Configuration Name',
  'lookuptype':'Lookup Type','objectlabel':'Object Label','parentobjectlabel':'Parent Object','dnsname':'DNS Name','databasename':'Database Name',
  'datasourceregion':'DataSource Region','noofsets':'Migration Sets','deferredsets':'Deferred Sets','s3bucketname':'s3bucketname',
'jsuiteversion':'JSuite Version','accesstoken': 'AccessToken','tenantname':'Workspace Name','bucketname':'Bucket Name',
'firstname':'First Name','lastname':'Last Name','phonenumber':'Phone Number','empno':'Employee Number',
'rolename':'Role Name','ftphostname':'FTP Host Name','ftpusername':'FTP User Name','propertyname':'Property Name',
'objecttype':'Object Type','fileName':'File Name','loadaction':'Load Action','parentobjectnameforextraction':'Parent ObjectName For Extraction','objectgroupname':'Object GroupName',
'filename__j': 'File Name','queryexecutiontype__j':'Query Execution Type','sourcetype__j':'Data Source Type'

};

const fieldsToCheck = specialCharRestrictedTables[this.tableName];
if (fieldsToCheck) {
  const invalidFields: string[] = [];
  for (const field of fieldsToCheck) {

    const control = this.formValid.get(field) as UntypedFormControl;

    if (control) {
      const validationResult = this.validation.specialCharacterValidator(control);

      if (validationResult && validationResult['specialCharacter']) {
        invalidFields.push(field);
      }
    } 
  }
  if (invalidFields.length > 0) {
     const fieldsList = invalidFields
    .map(field => uiFieldNames[field] || field).join(', ');

    this.snackbar.open(
      `Special characters are not allowed in: ${fieldsList}.`,
      'Close',
      { duration: 6000, panelClass: ['error-snackbar'] }
    );
    return;
  }
}

    
    console.log(this.selectedObjectDns)
    //Getting the username from localStorage.
    let userName = this.localStorageSettings.getSettings("AuthUsername");
  
    console.log(this.listObjectDropDown);
    
    console.log(this.ngModelObject);
   
    console.log(this.headerNameHtml)
    var keyvalueTenantName;
    var keyvalueSourceId;
    var keyvalueTargetId;
    var keyvalueJtestWorkspace
    console.log(this.tableName)
    if (this.tableName === "objectmetadata") {
      // Remove all objects with keyName === "objectMetadetaSelectedDnsName"
      this.ngModelObject = this.ngModelObject.filter(obj => obj.keyName !== "objectMetadetaSelectedDnsName");

      // Push the new object
      const obj = {
        keyName: "objectMetadetaSelectedDnsName",
        keyValue: this.selectedObjectDns,
        binaryFormat: false,
        tableName: "",
        status: "",
        fieldType: "",
        imageNameDisplay: null,
        passwordKey: ""
      };
    
      this.ngModelObject.push(obj);
    }
    console.log(this.ngModelObject);
    
    if (this.headerNameHtml === "Manage Workspace") {
      for (let i=0; i<this.ngModelObject.length; i++) {
          if (this.ngModelObject[i].keyName === "tenantname") {
            keyvalueTenantName = this.ngModelObject[i].keyValue;
            console.log(keyvalueTenantName)
            if (/[^a-z0-9\s]|[^\w\s]|[\s]/.test(keyvalueTenantName)) {
              this.snackBar.open("Tenant Name should not contain any special characters", "OK", { duration: 5000 });
              return
            }
          } else if (this.ngModelObject[i].keyName === "bucketname") {
            keyvalueTenantName = this.ngModelObject[i].keyValue;
            console.log(keyvalueTenantName)
            if (/[^a-z0-9\s-]|[\s]/.test(keyvalueTenantName)) {
              this.snackBar.open("Bucket Name should not contain any special characters", "OK", { duration: 5000 });
              return
            }
          } else if (this.ngModelObject[i].keyName === "vaultconfigmstridsource") {
              keyvalueSourceId = this.ngModelObject[i].keyValue; 
              console.log(keyvalueSourceId)
          } else if (this.ngModelObject[i].keyName === "vaultconfigmstridtarget") {
              keyvalueTargetId = this.ngModelObject[i].keyValue;
              console.log(keyvalueTargetId)
              if (keyvalueJtestWorkspace==='false' && keyvalueSourceId === keyvalueTargetId) {
                this.snackBar.open("Source and Target value should not be same", "OK", { duration: 5000 });
                return
              }
          } else if (this.ngModelObject[i].keyName === "jtestworkspace") {
              keyvalueJtestWorkspace = this.ngModelObject[i].keyValue;
              if(keyvalueJtestWorkspace=='')
                keyvalueJtestWorkspace='false';
              
              console.log(keyvalueJtestWorkspace)
          }
        }
    }

    //Getting the user record from users table using userName.
    let userObject: any = await this.service.retrieveSingleRecordService("users", "userName", userName);

    //console.log(userObject);

    let isExecute: any = 0;

    isExecute = this.trnxCommonTs.checkingCombinationColumnsUnique(this.ngModelObject, this.retrieveObject, isExecute);

    //console.log(isExecute);

    let approvedindex: any;

    let mmapprovalindex: any;

    let useridtemp: any;

    //console.log(this.ngModelObject)

    //Iterating ngModelObject object for storing value in tenantid.
    for (let i = 0; i < this.ngModelObject.length; i++) {
      console.log(this.ngModelObject)
         if(this.ngModelObject[i].fieldName==="sessionexpirationtime" && this.systemName!=="Vault"){
          this.ngModelObject[i].keyValue = 0;
         }
        //  else if(this.ngModelObject[i].fieldName==="burstlimitsleeptime" && this.systemName!=="vault"){
        //   this.ngModelObject[i].keyValue = 60;
        //  }else if(this.ngModelObject[i].fieldName==="vaultversion" && this.systemName!=="vault"){
        //   this.ngModelObject[i].keyValue = 20.1;
        //  }else if(this.ngModelObject[i].fieldName==="burstlimitsleeptime" && this.systemName!=="vault"){
        //   this.ngModelObject[i].keyValue = 60;
        //  }
      if (this.ngModelObject[i].keyName == "approvedby") {
        if (this.ngModelObject[i].fieldType == "Checkbox") {
          //console.log(this.ngModelObject[i].keyValue);
          useridtemp = i;
          if (this.ngModelObject[i].keyValue == true) {
            //Getting the tenantid from first json.
            //console.log(useridtemp)
            let userIdValue = userObject[0].userid;

            //console.log(userIdValue);

            //Storing the tenantid value in keyValue where keyName is tenantid.
            this.ngModelObject[i].keyValue = userIdValue;

            console.log(this.ngModelObject[i].keyValue);
          } else if (this.ngModelObject[i].keyValue == false) {
            this.ngModelObject[i].keyValue = "0";
          }
        }
      }
      if (this.ngModelObject[i].keyName == "approveddatetime") {

        //console.log(this.ngModelObject[i].keyValue);

        approvedindex = i;

      }
      if (this.ngModelObject[i].keyName == "mmapproval") {

        mmapprovalindex = i;

      }

    }

    if (useridtemp != undefined) {
      //console.log(useridtemp)
      if (this.ngModelObject[useridtemp].keyValue != 0) {
        const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
        let datetimevalue = moment(new Date(), DATE_TIME_FORMAT);

        //Storing the tenantid value in keyValue where keyName is tenantid.
        this.ngModelObject[approvedindex].keyValue = datetimevalue;
        this.ngModelObject[mmapprovalindex].keyValue = "Yes";
      } else {
        this.ngModelObject[approvedindex].keyValue = null;
        this.ngModelObject[mmapprovalindex].keyValue = "No";
      }

    }

    let isexist = "";
    let temporaryObject: any = [];

   // this.syncRepositoryTypeToNgModel();

    temporaryObject = this.trnxCommonTs.ngModelData(this.ngModelObject);
  
   
    if (this.headerNameHtml === 'Screen Element Repository') {
        temporaryObject.forEach(obj => {
  if (obj && obj.keyValue !== null && obj.keyValue !== undefined) {

   
    if (typeof obj.keyValue === 'string') {
      
    }
    else if (typeof obj.keyValue === 'number' || typeof obj.keyValue === 'boolean') {
      obj.keyValue = String(obj.keyValue);
    }
    else {
      
      obj.keyValue = null;
    }
  }
});
    }

    const overwriteObj = temporaryObject.find(o => o.keyName === 'overwrite_mode');

        if (overwriteObj) {
          if (overwriteObj.keyValue === 'Yes') {
            overwriteObj.keyValue = 'true';   
          } else {
            overwriteObj.keyValue = 'false';  
          }
       
        }



    console.log(temporaryObject);

    if (this.buttonNameClose == "Save") {

      // checking the form is valid or not while insert
      if (!this.formValid.valid) {

        // displaying validation messages

        this.validation.validateAllFormFields(this.formValid);
         /**
          * ModifiedBy-Asha Waghadure
         * Date-01-07-2025
       * added for Email Notification validation message
       */

          if(this.headerNameHtml=='Email Notification' && this.formValid.controls['emailids']){
            const emailControl = this.formValid.controls['emailids'];
                    if (emailControl?.errors?.['invalidEmails']) {
                      const invalidEmails = emailControl.errors['invalidEmails']; 
                      const invalidEmailsStr = invalidEmails.join(', ');
                      console.log("invalidEmail:"+invalidEmailsStr)
                      this.validation.getemailvalidationmessage(invalidEmailsStr);
                   }else{
                    this.validation.getvalidationmessage();
                    }
           }else{
             this.validation.getvalidationmessage();
           }
      }

      else {
        console.log(temporaryObject)
        for (let i = 0; i < temporaryObject.length; i++) {
          console.log(temporaryObject[i].keyName)
          if (temporaryObject[i].keyName == "materialid") {
            console.log(temporaryObject[i].keyValue)
            console.log(this.retrieveObject)
            for (let j = 0; j < this.retrieveObject.length; j++) {
              console.log(this.retrieveObject[j].materialid)
              if (this.retrieveObject[j].materialid === temporaryObject[i].keyValue) {
                console.log("entered")
                isexist = "true";
                this.snackBar.open("Material already inserted", "OK", { duration: 5000 });
              }
            }
          }
        }
        console.log(temporaryObject);

        console.log(this.tableName);

        console.log(isExecute);

        console.log(this.ngModelObject);

        console.log(this.tableID);

        console.log(this.temporaryChildObject);

        console.log(this.screenTypeTOrM);

        console.log(this.masterTableId);

        this.passwordEncrpt(temporaryObject);

        let response;

        response = await this.checkingIsExistInsert(isexist, temporaryObject, isExecute);

        await this.getResponse(response);

      }

    }

    else {
      /**
       * @ModifiedBy-Asha Waghadure
       * @Date-21-07-2025
       * @Note-when scriptype is Case Validation in Manage Test Scripts clearing validation for scripttype
       */
      if(this.headerNameHtml=="Manage Test Scripts" && this.buttonName == "Update"){
      const scriptTypeField = temporaryObject.find(e => e.keyName === 'scripttype');
            console.log(scriptTypeField); 
            if(scriptTypeField.dropDownValue=="Case Validation"){
                const control = this.formValid.controls['featurefilepathpath'];
                        if (control?.errors?.['required']) {
                      control.clearValidators();
                      control.setErrors(null);               
                      control.updateValueAndValidity();
                         }
            }
          }
      // checking the form is valid or not while update
      if (!this.formValid.valid) {
        console.log("djhdfhsf")
        console.log("Form Validity in IF: ", this.formValid.valid);
        console.log("Form Controls in IF: ", this.formValid.controls);
        // displaying validation messages
        console.log(this.formValid)
        
        this.validation.validateAllFormFields(this.formValid);
         /**
       * added for Email Notification validation message
       *  ModifiedBy-Asha Waghadure
       * Date-01-07-2025
       */
                       
           if(this.headerNameHtml=='Email Notification' && this.formValid.controls['emailids']){
            const emailControl = this.formValid.controls['emailids'];
                    if (emailControl?.errors?.['invalidEmails']) {
                      const invalidEmails = emailControl.errors['invalidEmails']; 
                      const invalidEmailsStr = invalidEmails.join(', ');
                      console.log("invalidEmail:"+invalidEmailsStr)
                      this.validation.getemailvalidationmessage(invalidEmailsStr);
                   }else{
                    this.validation.getvalidationmessage();
                    }
           }else{
             this.validation.getvalidationmessage();
           }




        

        this.spinner.stop()
      }

      else {
        console.log("Form Validity in else: ", this.formValid.valid);
        console.log("Form Controls in else: ", this.formValid.controls);
        console.log(temporaryObject)

        this.passwordEncrpt(temporaryObject);

        let response: boolean;

        response = await this.checkingIsExistUpdate(isexist, temporaryObject, isExecute);

        await this.getResponse(response);

        console.log(response)

        if(!response && this.externalObjectFileName){
          const formData = new FormData();
          console.log(this.externalObjectFile)
          formData.append('file', this.externalObjectFile)
          let tenantId=localStorage.getItem('dnsName');
     
          //formData.append('s3Path', "Migration/Vault_Objects")
      console.log(formData)
      console.log(formData.get)
  
       
         this.service.uploadExternalFileToS3(tenantId, formData).subscribe(res => {
          console.log(res);
          if (res.error === true) {
            //this.spinner.stop();
            this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
          } else {
            
          //  this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
          }
        })
  
  
        }


      }

    }

  }

  changeStartEndDateValue(ngModelTemporary) {

    this.trnxCommonTs.changeStartEndDateValue(ngModelTemporary, this.ngModelObject);

  }

  changeStartEndDateTimeValue(ngModelTemporary) {

    this.trnxCommonTs.changeStartEndDateTimeValue(ngModelTemporary, this.ngModelObject);

  }

  async next(value) {

let flag=true;

    if(this.externalObjectFileName){
      for(let a=0;a<this.ngModelObject.length;a++){
       if(this.ngModelObject[a].keyName ==="objectname"){
          console.log(this.ngModelObject[a].keyValue+".csv")
          console.log(this.externalObjectFile.name)
          if((this.ngModelObject[a].keyValue+".csv") != this.externalObjectFile.name ){
            flag=false;
            this.snackbar.open("File name should be same as object name", "OK", { duration: 5000 });
          }
          console.log(this.ngModelObject[a]);
        }
       }
    } 
if(flag){ 
    // checking the form is valid or not while insert
    if (!this.formValid.valid) {

      // displaying validation messages

      this.validation.validateAllFormFields(this.formValid);
      console.log(this.formValid)
            console.log(this.formValid.controls)
             /**
       * added for Email Notification validation message
       *  ModifiedBy-Asha Waghadure
       * Date-01-07-2025
       */

      if(this.headerNameHtml=='Email Notification' && this.formValid.controls['emailids']){
            const emailControl = this.formValid.controls['emailids'];
                    if (emailControl?.errors?.['invalidEmails']) {
                      const invalidEmails = emailControl.errors['invalidEmails']; 
                      const invalidEmailsStr = invalidEmails.join(', ');
                      console.log("invalidEmail:"+invalidEmailsStr)
                      this.validation.getemailvalidationmessage(invalidEmailsStr);
                   }else{
                    this.validation.getvalidationmessage();
                    }
           }else{
             this.validation.getvalidationmessage();
           }

    }

    else {

      console.log(this.screenTypeTOrM);

      if (this.screenTypeTOrM == "Transaction") {

        console.log(this.screenTypeTOrM);

        let retrieveChildNgModelCreation: any = [];
        retrieveChildNgModelCreation = await this.trnxCommonTs.retrieveChildTableData(value);
        this.parentScreen = false;
        this.childScreen = true;
        this.ngModelChildObjectDivision = retrieveChildNgModelCreation[2];
        this.ngModelChildObject = retrieveChildNgModelCreation[1];
        this.childDynamicData = retrieveChildNgModelCreation[0];
        console.log(this.ngModelChildObject)
        console.log(this.childDynamicData)
        console.log(this.ngModelChildObjectDivision);
        this.childFormValidations()
        for (let i = 0; i < this.childDynamicData.length; i++) {

          if (this.childDynamicData[i].fieldType == "valueDropDown" || this.childDynamicData[i].fieldType == "valueParentDropDown" || this.childDynamicData[i].fieldType == "Linked Fields") {

            console.log(this.childDynamicData[i].fieldName);

            console.log(this.childDynamicData[i]);

            /*this.dropDowns.push([this.dynamicData[i].fieldName, this.dynamicData[i].dropDownIndex, this.dynamicData[i].agGridDecode, this.dynamicData[i].dropDownIDs, this.dynamicData[i].dropDownValues]);

            console.log(this.dropDowns);*/

            this.listChildObjectDropDown[this.childDynamicData[i].dropDownIndex] = await this.trnxCommonTs.retrieveTrnxDropDown(this.childDynamicData[i].dropDownTableName, /*this.dynamicData[i].dropDownIdNameFilter, this.dynamicData[i].dropDownIdValueFilter,*/ this.childDynamicData[i].dropDownIDs, this.childDynamicData[i].dropDownValues, this.childDynamicData[i].lookupTableName);

            /*Modified By-Renuka Chama
             * Date-24-12-2025
             * Note- To sort the test case dropdown values in desc order based on id for managetestscriptsmstrid field in testcyclemstr table.
             */
            if (this.tableName === 'testcyclemstr' &&
              this.childDynamicData[i].fieldName === 'managetestscriptsmstrid') {
              const dropIndex = this.childDynamicData[i].dropDownIndex;
              if (this.listChildObjectDropDown[dropIndex]) {
                this.listChildObjectDropDown[dropIndex] = [
                  ...this.listChildObjectDropDown[dropIndex]
                ].sort((a: any, b: any) => {
                  const idA = a.managetestscriptsmstrid || a.lookupvalueid || 0;
                  const idB = b.managetestscriptsmstrid || b.lookupvalueid || 0;
                  return idB - idA;
                });
              }
            }
            console.log(this.listChildObjectDropDown);

          }
          if (this.childDynamicData[i].fieldType == "Select List - Static") {

            console.log(this.childDynamicData[i].fieldName);

            console.log(this.childDynamicData[i]);

            /*this.dropDowns.push([this.dynamicData[i].fieldName, this.dynamicData[i].dropDownIndex, this.dynamicData[i].agGridDecode, this.dynamicData[i].dropDownIDs, this.dynamicData[i].dropDownValues]);

            console.log(this.dropDowns);*/

            this.listChildObjectDropDown[this.childDynamicData[i].dropDownIndex] = await this.trnxCommonTs.retrieveTrnxDropDown(this.childDynamicData[i].dropDownTableName, /*this.dynamicData[i].dropDownIdNameFilter, this.dynamicData[i].dropDownIdValueFilter,*/ this.childDynamicData[i].dropDownIDs, this.childDynamicData[i].dropDownValues, this.childDynamicData[i].lookupTableName);

            console.log(this.listChildObjectDropDown);

          }

        }

      }

      else {

        this.sendDataAndClose();

      }

    }
  }
  }


  async addData() {
    console.log("Inside add data function")

    if (!this.formChildValid.valid) {

      // displaying validation messages

      this.validation.validateAllFormFields(this.formChildValid);
      /**
       * added for Email Notification validation message
       *  ModifiedBy-Asha Waghadure
       * Date-01-07-2025
       */

      if(this.headerNameHtml=='Email Notification' && this.formValid.controls['emailids']){
            const emailControl = this.formValid.controls['emailids'];
                    if (emailControl?.errors?.['invalidEmails']) {
                      const invalidEmails = emailControl.errors['invalidEmails']; 
                      const invalidEmailsStr = invalidEmails.join(', ');
                      console.log("invalidEmail:"+invalidEmailsStr)
                      this.validation.getemailvalidationmessage(invalidEmailsStr);
                   }else{
                    this.validation.getvalidationmessage();
                    }
           }else{
             this.validation.getvalidationmessage();
           }

    } else {
      // this.eachDetailsData.push(this.ngModelChildObject)
      // console.log(this.eachDetailsData)
      this.bindingDetailsData = [];
      let count = 1;
      this.temporaryChildObject.push(this.trnxCommonTs.ngModelChildData(this.ngModelChildObject));
      console.log(this.temporaryChildObject)
      for (let i = 0; i < this.temporaryChildObject.length; i++) {
        this.eachDetailsData = [];
        for (let j = 0; j < this.temporaryChildObject[i].length; j++) {
          console.log(this.temporaryChildObject[i][j])
          if (this.temporaryChildObject[i][j].fieldType == "Linked Fields" || this.temporaryChildObject[i][j].fieldType == "Select List - Static") {
            if (this.temporaryChildObject[i][j].showForm == true) {
              for (let m = 0; m < this.listChildObjectDropDown.length; m++) {
                // for(let n=0;n<this.listChildObjectDropDown[m].length;n++){
                console.log(this.temporaryChildObject[i][j].keyName)
                console.log(Object.keys(this.listChildObjectDropDown[m][0]))
                let keys = Object.keys(this.listChildObjectDropDown[m][0]);
                if (this.temporaryChildObject[i][j].keyName == "applicationname" && this.headerNameHtml=="JSuite Version Management") {
                  console.log(this.temporaryChildObject[i][j])
                  for (let n = 0; n < this.listChildObjectDropDown[m].length; n++) {
                    let values = Object.values(this.listChildObjectDropDown[m][n]);
                    for (let k = 0; k < values.length; k++) {
                      console.log(count)
                      if (this.temporaryChildObject[i][j].keyValue == values[k]) {
                        if (count == 1) {
                          console.log(this.listChildObjectDropDown[m][n].dropDownValueDisplay)
                          this.detailValue = this.listChildObjectDropDown[m][n].dropDownValueDisplay;
                          this.eachDetailsData.push({ parentName: this.temporaryChildObject[i][j].fieldType, childValue: this.detailValue })
                          count++
                        }
                      }
                    }

                  }
                }
                else{
                  if (this.temporaryChildObject[i][j].keyName == keys[0]) {
                    console.log(this.temporaryChildObject[i][j])
                    for (let n = 0; n < this.listChildObjectDropDown[m].length; n++) {
                      // let values = Object.values(this.listChildObjectDropDown[m][n]);
                      let values = [ this.listChildObjectDropDown[m][n][keys[0]] ];
                      for (let k = 0; k < values.length; k++) {
                        console.log(count)
                        if (this.temporaryChildObject[i][j].keyValue == values[k]) {
                          if (count == 1) {
                            console.log(this.listChildObjectDropDown[m][n].dropDownValueDisplay)
                            this.detailValue = this.listChildObjectDropDown[m][n].dropDownValueDisplay;
                            this.eachDetailsData.push({ parentName: this.temporaryChildObject[i][j].fieldType, childValue: this.detailValue })
                            count++
                          }
                        }
                      }
  
                    }
                }

              }

              }
            }
          }
          else {
            if (this.temporaryChildObject[i][j].showForm == true) {
              this.eachDetailsData.push({ parentName: this.temporaryChildObject[i][j].fieldType, childValue: this.temporaryChildObject[i][j].keyValue })
            }
          }
        }

        this.bindingDetailsData.push(this.eachDetailsData)
        count = 1;
      }
      console.log(this.eachDetailsData)

      console.log(this.bindingDetailsData)
      this.resetChild();
    }

  }

  removeData(removeId) {
    console.log(removeId)
    this.temporaryChildObject.splice(removeId, 1)
    this.bindingDetailsData.splice(removeId, 1)
  }

  docdownload(ngModelTemporary) {

    console.log(ngModelTemporary);

    let imageName = "";

    this.ngModelObject.forEach(inputObject => {

      if (inputObject.keyName == ngModelTemporary.imageName) {

        imageName = inputObject.keyValue;

      }

    });

    console.log(imageName);
    let s3FilePath =ngModelTemporary.keyValue

    let keyName = ngModelTemporary.keyName

    if (s3FilePath !='' && s3FilePath != null && s3FilePath !=undefined) {
      // let fileName =  e.rowData[0]

      let fileName =  s3FilePath.substring(s3FilePath.indexOf(keyName+"_") + keyName.length + 1);
      if (s3FilePath.includes("managetestscriptsmstr")) {
        fileName = imageName;
    }
    
      
       let data = {
        's3Path':s3FilePath,
      };
      this.spinner.start();
      this.service.downloadFileFromS3(data).subscribe(x => {
        this.spinner.stop()
        // It is necessary to create a new blob object with mime-type explicitly set
        // otherwise only Chrome works like it should

        console.log(x)
        const isJsonBlob = (data) => data instanceof Blob && data.type === "application/json";
        const responseData = isJsonBlob(x)
        if (responseData){
          this.snackbar.open(this.constants.fileNotFound, "OK", {duration: 5000});

        }
        else{
          console.log(x)
          var newBlob = new Blob([x]);
          // IE doesn't allow using a blob object directly as link href
          // instead it is necessary to use msSaveOrOpenBlob
          // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          //   window.navigator.msSaveOrOpenBlob(newBlob);
          //   return;
          // }

          // For other browsers:
          // Create a link pointing to the ObjectURL containing the blob.
          const data = window.URL.createObjectURL(newBlob);
          console.log(data)

          var link = document.createElement('a');
          link.href = data;
          link.download = fileName;
          // this is necessary as link.click() does not work on the latest firefox
          link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
          setTimeout(function () {
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(data);
            link.remove();
          }, 100);

        }




      })
    }else{

      this.snackbar.open(this.constants.fileNotFound, "OK", {duration: 5000});

    }
  }

  cancel() {

    this.reset();

    //It will reset checkbox form.
    this.formValidCheckbox.reset();

    //It will call checkbox formValidationCheckbox method.
    this.formValidationsCheckbox();

    this.externalObjectFileName=false;
    this.externalObjectFile=false;

    this.data.listObjectDropDown = [];

    this.listObjectDropDownDuplicate.forEach(listObjectTemp => {

      this.data.listObjectDropDown.push(listObjectTemp);

    });

    console.log(this.data.listObjectDropDown);

    console.log(this.listObjectDropDownDuplicate);

    this.dialogref.close(this.data.listObjectDropDown);
    console.log(this.ngModelObject)

    for(let a=0;a<this.ngModelObject.length;a++){
      if(this.ngModelObject[a].keyName ==="objecttype"){
        this.ngModelObject[a].value ="";
        console.log(this.ngModelObject[a]);
      }
     }

  }

  // cancelChild(){
  //   this.resetChildData();

  //   this.data.listObjectDropDown = [];

  //   this.listObjectDropDownDuplicate.forEach(listObjectTemp => {

  //     this.data.listObjectDropDown.push(listObjectTemp);

  //   });

  //   console.log(this.data.listObjectDropDown);

  //   console.log(this.listObjectDropDownDuplicate);

  //   this.dialogref.close(this.data.listObjectDropDown);


  // }

  checkingDuplicateInNgModel(keyName,ngModelObject){
   let arr=[]
   console.log(this.ngModelObject);
    for(let i=0; i<this.ngModelObject.length; i++){
     
      if(this.ngModelObject[i].keyName==keyName){
           console.log(keyName);
        this.ngModelObject.splice(i,1);
        
        
      }
      else{
        arr.push(ngModelObject[i]);
      }
    }
    //console.log(this.ngModelObject);
    //this.ngModelObject=arr;
     console.log(arr);
    console.log(this.ngModelObject);
  }
addingAdditionalParameters(ngModelTemporary,droupDownBindedName,droupDownBindedId,agGridColumnNameOfDynamicData){
console.log(ngModelTemporary,droupDownBindedName,droupDownBindedId,agGridColumnNameOfDynamicData+"++++++++++++++++++++++")
  
  let arr=[];
  
  
  for(let i=0; i<this.listObjectDropDown.length; i++){
  for(let j=0; j<this.listObjectDropDown[i].length; j++){
   
    let obj={}
    
    obj['dropDownValue']=this.listObjectDropDown[i][j][droupDownBindedName];
    obj['dropDownId']=this.listObjectDropDown[i][j][droupDownBindedId];
   if(this.listObjectDropDown[i][j][droupDownBindedName]!=undefined){
    arr.push(obj);
   }

   
   console.log(droupDownBindedName);
    if(this.listObjectDropDown[i][j][droupDownBindedId]==ngModelTemporary.keyValue&&ngModelTemporary.agGridColumnName==agGridColumnNameOfDynamicData){
      
      this.checkingDuplicateInNgModel(ngModelTemporary.keyName,this.ngModelObject);
      
      ngModelTemporary['value']=this.listObjectDropDown[i][j][droupDownBindedName];


     
      
    }
    
  }
  
  }
  ngModelTemporary['dropDownIdValues']=arr;
  console.log(this.ngModelObject)
  this.checkingDuplicateInNgModel(ngModelTemporary.keyName,this.ngModelObject);
  this.ngModelObject.push(ngModelTemporary);
   console.log(this.ngModelObject);
  console.log(arr);
}

multiSelectselectionChange(ngModelTemporary){
  console.log("&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&");

  console.log(ngModelTemporary);
}
// retrieveSourceDNS(){
//     let workspaceid = this.localStorageSettings.getSettings('WorkspaceId');

//     this.reportService.retrieveSourceDNSByWorkspaceId(workspaceid).subscribe((res:any)=>{
//       if(res == undefined || res == null){
//         this.snackbar.open("Source DNS not found. Please configure atleast one dns as source to continue.", "OK", {duration: 5000});
//       } else{
//         console.log(res);
//         this.listOfSourceDNS=res
//          if (this.listOfSourceDNS && this.listOfSourceDNS.length > 0) {
//           this.sourceDNSId =this.listOfSourceDNS[0].vaultConfigMstrId;
//          }
//       }
//     })
//   }
  
 async childDropDown(ngModelTemporary) {
   console.log('Selected value:', ngModelTemporary.keyValue);
console.log("&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&");


// In childDropDown method or where dropdown is populated:
console.log('Dropdown options for repository_type:', 
  this.listObjectDropDown[ngModelTemporary.dropDownIndex]);
if (ngModelTemporary.keyName === 'repository_type') {

  const lookupId = Number(ngModelTemporary.keyValue);
  const dropdownList = this.listObjectDropDown[ngModelTemporary.dropDownIndex];

  if (!dropdownList || isNaN(lookupId)) {
    return;
  }

  const match = dropdownList.find(
    (item: any) => item.lookupvalueid === lookupId
  );

  if (match) {
   
    this.repositoryType = match.lookupvalue as 'Custom' | 'Standard';

    if (this.repositoryType === 'Standard') {
      this.loadPageLayouts();
    }
  }

  return; // 🔒 stop further processing for this dropdown
}




  if (this.headerNameHtml === "Manage Workspace") {
    if (ngModelTemporary.agGridColumnName === "Company") {
      this.companyId = ngModelTemporary.keyValue;
      console.log(ngModelTemporary.keyValue)
      console.log(this.companyId);
    }
    if (ngModelTemporary.agGridColumnName === "JTest Workspace") {
      this.isJtestWorkspace = ngModelTemporary.keyValue;
      console.log(ngModelTemporary.keyValue)
      //  if(this.isJtestWorkspace=='')
      //           this.isJtestWorkspace='false';
      console.log(this.isJtestWorkspace);
    }
  }
   	  
	if (this.headerNameHtml === "Data Source Configuration") {
    if(ngModelTemporary.agGridColumnName === "System Name"){
      this.systemnameForVaultAuthtype = ngModelTemporary.keyValue;
      console.log(ngModelTemporary.keyValue)
      this.spinner.start()
      this.loginService.getSystemNamebyid(this.systemnameForVaultAuthtype).subscribe(resp => {
        this.spinner.stop()
    if (resp['data'].toLowerCase() === "vault") {
      this.showAuthName = true;
      this.setAuthNameMandatory(true);
    } else {
      this.showAuthName = false;
       this.setAuthNameMandatory(false);
      this.formValid.get('vaultauthtype')?.reset();
    }

    });

    }
   }
  

  let system: string | null = "";
    let agGridColumnNameOfDynamicData;
   let droupDownBindedName
   let droupDownBindedId
   console.log(ngModelTemporary);
    
   let lookupid = ngModelTemporary.keyValue;
   let keyName = ngModelTemporary.keyName
   console.log(lookupid);
    if(lookupid != ""){
      const res = await (await this.loginService.getsystemName(lookupid)).toPromise();
      console.log(res);
      
      if (res && res.data) {
        system = res.data.toLowerCase();
      } else {
        system = ''; // or any default value you want to use
      }
  console.log(system);    
 if(system !== "external objects" && this.data.buttonName !="Update"){
  console.log(system); 
 // this.clearFileSelection();
 this.externalObjectFileName=false;
 this.externalObjectFile=undefined;
  console.log(ngModelTemporary.keyValue,ngModelTemporary.value)
 // ngModelTemporary.keyValue=ngModelTemporary.value;
 }

        }
        const targetValue = '20.1';
        let lookupvalueid: number | undefined;
        console.log(this.listObjectDropDown)
        console.log(this.listObjectDropDown.length)
      if (this.listObjectDropDown.length >= 6) {
        const fifthArray = this.listObjectDropDown[5]; 
        for (const obj of fifthArray) {
          if (obj.dropDownValueDisplay === targetValue) {
              lookupvalueid = obj.lookupvalueid;
              break; 
            }
          }
      }


        console.log(`Found lookupvalueid: ${lookupvalueid}`);

    for (let i = 0; i < this.dynamicData.length; i++) {
         /**
         * ModifiedBy-Asha Waghadure
         * Date-18-07-2025
         * added for managetestscriptsmstr to display Action File based on script type
         */
        // if (this.headerNameHtml === "Manage Test Scripts") {
        //     if (system=="record validation") {
        //           this.isSelected=true
        //     }else if(system=="record creation"){
        //           this.isSelected=false
        //     }
        //    console.log(this.isSelected)
        //    this.displayActionFileBasedOnScriptType(this.isSelected); 
        // }  
            
             console.log(system);
         
          if(this.dynamicData[i].fieldName==="sessionexpirationtime" && system =='vault'&& keyName=="systemname"){
            this.systemName = "Vault"
           console.log(system)
            this.dynamicData.forEach(e =>{
              if(e.fieldName ==="sessionexpirationtime"){
               e.mandatory = true
               e.keyValue = null;
               this.cdr.detectChanges();
              }
           })
            
          }
          else if(this.dynamicData[i].fieldName==="sessionexpirationtime" && system!= 'vault'&& keyName=="systemname"){
            this.systemName= "";
            console.log(system)
            this.dynamicData.forEach(e =>{
              if(e.fieldName ==="sessionexpirationtime"){
                console.log(this.dynamicData[i]);
               e.mandatory = false
               
               this.ngModelObject.forEach(e=>{
                if(e.fieldName==="sessionexpirationtime"){
                  e.keyValue = 0
                  this.cdr.detectChanges();
                }
               })
              //  this.cdr.detectChanges();
            
              }
           })
           
          }
          /*
          Author: Raghottam Joshi
          Date:14-07-2024
          changes in base screen according to vault and NON-vault in data Source Configuration
          */
            else if(this.headerNameHtml === "Data Source Configuration" && 
            ngModelTemporary.agGridColumnName==="System Name" && system!= 'vault'&& keyName=="systemname"){
              console.log( this.dynamicData)
              
              this.dynamicData.forEach(e =>{
              if(e.fieldName ==="sessionexpirationtime"){
                console.log(this.dynamicData[i]);
               e.mandatory = false
               e.showForm=false
              //  this.formValid.controls.sessionexpirationtime = new UntypedFormControl("");
              // this.formValid.setControl('sessionexpirationtime', new UntypedFormControl(0));

               this.ngModelObject.forEach(e=>{
                if(e.fieldName==="sessionexpirationtime"){
                  e.keyValue = 0
                  e.mandatory=false
  
                  // e.showForm=false
                  this.cdr.detectChanges();
                }
               })
               
            
              }else if(e.fieldName ==="vaultversion"){
                e.mandatory = false
                e.showForm=false
                // this.formValid.controls.vaultversion = new UntypedFormControl("",[Validators.required]);
                // this.formValid.setControl('vaultversion', new UntypedFormControl('',[Validators.nullValidator]));//Chages Made by 

                console.log(e)
               this.ngModelObject.forEach(e=>{
                if(e.fieldName==="vaultversion"){
                  console.log(e)
                  e.keyValue = lookupvalueid
                  e.mandatory=false
                  e.showForm=false
                 
                  this.cdr.detectChanges();
                }
               })
              //  this.cdr.detectChanges();
              }
              else if(e.fieldName ==="burstlimitthreshold"){
                e.mandatory = false
                // this.formValid.controls.burstlimitthreshold = new UntypedFormControl("",[Validators.required]);
                // this.formValid.setControl('burstlimitthreshold', new UntypedFormControl(0, [Validators.required]));
                // this.formValid.setControl('burstlimitthreshold', new UntypedFormControl('', [Validators.nullValidator]));

                // e.showForm=false
               this.ngModelObject.forEach(e=>{
                if(e.fieldName==="burstlimitthreshold"){
                  e.keyValue = "0"
                  e.mandatory=false
                 
                  // e.showForm=false
                  this.cdr.detectChanges();
                }
               })

              }
              else if(e.fieldName ==="burstlimitsleeptime"){
                e.mandatory = false
                // this.formValid.controls.burstlimitsleeptime = new UntypedFormControl("",[Validators.required]);
                // this.formValid.setControl('burstlimitsleeptime', new UntypedFormControl('', [Validators.nullValidator]));

                // e.showForm=false
               this.ngModelObject.forEach(e=>{
                if(e.fieldName==="burstlimitsleeptime"){
                  e.keyValue = 60;
                  e.mandatory=false
                 
                  // e.showForm=false
                  this.cdr.detectChanges();
                }
               })
               
              }
              // this.cdr.detectChanges();
           })

            }

             if(this.headerNameHtml === "Data Source Configuration" && 
              ngModelTemporary.agGridColumnName==="System Name" && system == 'vault'&& keyName=="systemname"){
                this.dynamicData.forEach(e =>{
                if(e.fieldName ==="sessionexpirationtime"){
                  console.log(this.dynamicData[i]);
                 e.mandatory = true
                //  e.showForm= true
                
                 this.ngModelObject.forEach(e=>{
                  if(e.fieldName==="sessionexpirationtime"){
                    e.keyValue = null
                    e.mandatory= true
                    // e.showForm= true
                    this.cdr.detectChanges();
                  }
                 })
                  console.log(e.fieldType)
                //   this.formValid.setControl('sessionexpirationtime', new UntypedFormControl(
                //     null, 
                //     [
                //         Validators.max(e.maxValuee), 
                //         Validators.min(e.minValue), 
                //         Validators.pattern('^-?[0-9]\\d*(\\.\\d*)?$'), 
                //         Validators.required
                //     ]
                // ));
                //  this.cdr.detectChanges();
              
                }else if(e.fieldName ==="vaultversion"){
                  // e.mandatory = true
                  // e.showForm=true
                 
                 this.ngModelObject.forEach(e=>{
                  if(e.fieldName==="vaultversion"){
                    e.keyValue = null
                    e.mandatory= true
                    e.showForm= true
                    this.cdr.detectChanges();
                  }
                 })
                 console.log(e.fieldType)
                //  this.formValid.setControl('vaultversion', new UntypedFormControl(null, [Validators.required]));
                //  this.cdr.detectChanges();
                }
                else if(e.fieldName ==="burstlimitthreshold"){
                  // e.mandatory = true
                  // e.showForm= true
                 
                 this.ngModelObject.forEach(e=>{
                  if(e.fieldName==="burstlimitthreshold"){
                    e.keyValue = null
                    e.mandatory= true
                    // e.showForm= true
                    this.cdr.detectChanges();
                  }
                 })
                 console.log(e.fieldType)
                //  this.formValid.controls.burstlimitthreshold = new UntypedFormControl("", [Validators.max(e.maxValuee), Validators.min(e.minValue), Validators.pattern('^-?[0-9]\\d*(\\.\\d*)?$'), Validators.required]);
                // this.formValid.setControl('burstlimitthreshold', new UntypedFormControl(null, [Validators.required]));

                //  this.cdr.detectChanges();
                }
                else if(e.fieldName ==="burstlimitsleeptime"){
                  e.mandatory = true
                  // e.showForm=true
                  
                 this.ngModelObject.forEach(e=>{
                  if(e.fieldName==="burstlimitsleeptime"){
                    e.keyValue = null;
                    e.mandatory=true
                    // e.showForm=true
                    this.cdr.detectChanges();
                  }
                 })
                 console.log(e.fieldType)
                //  this.formValid.controls.burstlimitsleeptime = new UntypedFormControl("", [Validators.max(e.maxValuee), Validators.min(e.minValue), Validators.pattern('^-?[0-9]\\d*(\\.\\d*)?$'), Validators.required]);
                // this.formValid.setControl('burstlimitsleeptime', new UntypedFormControl(null, [Validators.required]));

                //  this.cdr.detectChanges();
                }
                // this.cdr.detectChanges();
             })
  
              }
        
          console.log(this.dynamicData[i]);
          console.log(this.dynamicData);
          
      if (this.dynamicData[i].fieldType == "valueDropDown" || this.dynamicData[i].fieldType == "valueParentDropDown" || this.dynamicData[i].fieldType == "Linked Fields") {
        if(this.dynamicData[i].agGridColumnName==ngModelTemporary.agGridColumnName){

       

        console.log(this.dynamicData[i].fieldName);

        console.log(this.dynamicData[i]);
       
      
       
        console.log(this.dynamicData[i].dropDownIDs);
        droupDownBindedId=this.dynamicData[i].dropDownIDs;
        droupDownBindedName=this.dynamicData[i].dropDownValues;
        agGridColumnNameOfDynamicData=this.dynamicData[i].agGridColumnName;
     

       this.addingAdditionalParameters(ngModelTemporary,droupDownBindedName,droupDownBindedId,agGridColumnNameOfDynamicData)
        }
        
      }
      if (this.dynamicData[i].fieldType == "Select List - Static") {
        if(this.dynamicData[i].agGridColumnName==ngModelTemporary.agGridColumnName){

        console.log(this.dynamicData[i].fieldName);
        console.log(this.dynamicData[i]);
        console.log(ngModelTemporary.agGridColumnName)
        console.log(this.dynamicData[i].dropDownIDs);
        console.log(this.dynamicData[i].dropDownValues)
      
       
        
        agGridColumnNameOfDynamicData=this.dynamicData[i].agGridColumnName;
        droupDownBindedId=this.dynamicData[i].dropDownIDs;
        droupDownBindedName=this.dynamicData[i].dropDownValues;
      
 //console.log(droupDownBindedId)
 // console.log("+++++++++++++++++ In Second")
//  console.log(droupDownBindedName);

        this.addingAdditionalParameters(ngModelTemporary,droupDownBindedName,droupDownBindedId,agGridColumnNameOfDynamicData)

      }
    }

    }

    console.log(this.dynamicData);
   
// console.log(ngModelTemporary);
// console.log(this.dynamicData);
// console.log(this.ngModelObject);
// console.log(this.listObjectDropDown[0])

   
// console.log(this.listObjectDropDown);
// console.log(this.formChildValid);
  

    if (ngModelTemporary.dropDownChildFieldName != undefined && ngModelTemporary.keyValue != "" && ngModelTemporary.keyValue != undefined) {

      console.log(ngModelTemporary);

      let dropDownChildFieldName = ngModelTemporary.dropDownChildFieldName;

      let keyName = ngModelTemporary.keyName;
      console.log(keyName)

      let keyValue = ngModelTemporary.keyValue;
      console.log(keyValue)
      let childDropDownIndex: any = 0;
      console.log(this.ngModelObject);
      console.log(dropDownChildFieldName);
     

      this.ngModelObject.forEach(ngModelObjectTemp => {

        console.log(ngModelObjectTemp);
        console.log(dropDownChildFieldName);
        

        if (dropDownChildFieldName == ngModelObjectTemp.keyName) {

          console.log(dropDownChildFieldName);

          console.log(ngModelObjectTemp.keyName);

          childDropDownIndex = ngModelObjectTemp.dropDownIndex;

          //When the popup is open ngmodelchange function will execute for that to stop keyValue empty
          if (this.buttonName == "Update" && this.childrenDropDownsIncrement < this.numberOfChildrenDropDowns) {

            this.childrenDropDownsIncrement++;

            console.log(this.childrenDropDownsIncrement);

          }

          else {

            ngModelObjectTemp.keyValue = "";

          }
        }

      });

      console.log(childDropDownIndex);

      console.log(this.listObjectDropDownDuplicate);

      let temporaryArray: any = [];

      this.listObjectDropDownDuplicate[childDropDownIndex].forEach(listObjectTemp => {
        console.log(keyValue)
        console.log(listObjectTemp)
        if (listObjectTemp[keyName] == keyValue) {

          temporaryArray.push(listObjectTemp);

        }

      });

     
      this.listObjectDropDown[childDropDownIndex] = temporaryArray;
      

      console.log(this.listObjectDropDown);

    }

    console.log(this.listObjectDropDown);
      if(this.headerNameHtml === "Source Data Extraction Queries" && ngModelTemporary.fieldName == "objectgroupid" && ngModelTemporary.fieldType == "Select List - Static"){
        
          let dnsId = this.localStorageSettings.getSettings("dnsName");
          this.spinner.start();
           let workspaceid = this.localStorageSettings.getSettings('WorkspaceId');

    await this.reportService.retrieveSourceDNSByWorkspaceId(workspaceid).subscribe((res:any)=>{
      if(res == undefined || res == null){
        this.snackbar.open("Source DNS not found. Please configure atleast one dns as source to continue.", "OK", {duration: 5000});
      } else{
        console.log(res);
        this.listOfSourceDNS=res
         if (this.listOfSourceDNS && this.listOfSourceDNS.length > 0) {
          this.sourceDNSId =this.listOfSourceDNS[0].vaultConfigMstrId;
          this.service.getObjectsWithObjectGroup(dnsId,ngModelTemporary.value,this.sourceDNSId).subscribe((res:any)=>{
          console.log(res);
          if(res.error == true){
                    // this.spinner.stop();
                    this.listOfObjectsWithGroup=[]
                    this.snackbar.open(res.statusMessage, "OK", {
                      duration: 5000,
                    });
                  }else{
                    this.listOfObjectsWithGroup=res
                  }
          console.log(this.listOfObjectsWithGroup);
          this.cdr.detectChanges();
          this.spinner.stop();
        })
         }
        }
      })
        

      }

  }


  
  getSanitizer(keyValue) {

    return this.sanitizer.bypassSecurityTrustUrl(keyValue);

  }

  formValidationsCheckbox() {
    // form validations
    this.formValidCheckbox = new UntypedFormGroup({
      isCheckboxSelected: new UntypedFormControl("")
    });

  }

  //It will call when click on cancel button.
  closeFunction() {

    //Making isCheckboxSelected to false. To close the popup.
    this.isCheckboxSelected = false;

    this.close();

  }

  //This method is executing to checking respone value is true or false.
  getResponse(response) {

    console.log(response);

    console.log(typeof response);

    if (response == false) {

      //It will execute when response has value false. It means record is inserted successfully.
      console.log(response);

      this.close();

    }

  }

  //This method is executing to compare isexist value.
  async checkingIsExistInsert(isexist, temporaryObject, isExecute) {

    if (isexist !== "true") {

      //It will generate response, it has value true or false.
      let response = await this.trnxCommonTs.insertTrnxData(temporaryObject, this.tableName, isExecute, this.ngModelObject, this.tableID, this.temporaryChildObject, this.screenTypeTOrM, this.childKey, this.masterTableId);

      //Printing the response.
      console.log(response);

      console.log(typeof response);
      console.log(response ,this.externalObjectFileName)
      if(!response && this.externalObjectFileName){
        const formData = new FormData();
        console.log(this.externalObjectFile)
        formData.append('file', this.externalObjectFile)
        let tenantId=localStorage.getItem('dnsName');
   
        //formData.append('s3Path', "Migration/Vault_Objects")
    console.log(formData)
    console.log(formData.get)

     
       this.service.uploadExternalFileToS3(tenantId, formData).subscribe(res => {
        console.log(res);
        if (res.error === true) {
          //this.spinner.stop();
          this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
        } else {
          
        //  this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
        }
      })


      }

      return await response;

    }

  }

  async checkingIsExistUpdate(isexist, temporaryObject, isExecute) {

    if (isexist !== "true") {

      //It will generate response, it has value true or false.
      /*
      Author: D.Chaitanya
      Date:27-04-2022
      Passing primary key as a parameter
      */
      let response = await this.trnxCommonTs.updateTrnxData(temporaryObject, this.tableName, isExecute, this.ngModelObject, this.tableID,this.keyValues);

      //Printing the response.
      console.log(response);

      return await response;

    }

  }

  passwordEncrpt(temporaryObject) {

    console.log("temporaryObject");

    console.log(temporaryObject);

    temporaryObject.forEach(temporaryObjectTemp => {

      console.log()

      if (temporaryObjectTemp.fieldType == "Password") {

        if ((temporaryObjectTemp.keyValue != undefined) && (temporaryObjectTemp.keyValue != null)) {

          if (temporaryObjectTemp.keyValue.toString() != "") {

            console.log(temporaryObjectTemp.fieldType);

                        //chaitanya
            //27-07-2022
            //storing the servicepassword in the passwordKey

            // temporaryObjectTemp.passwordKey = this.auth.encrpt(this.auth.encrptKey, temporaryObjectTemp.keyValue);
            temporaryObjectTemp.passwordKey = temporaryObjectTemp.keyValue;

            //chaitanya
            //18-08-2022
            //removing the KeyValue
            temporaryObjectTemp.keyValue ="";
          }

        }

      }

    });

  }

  scheduleIntervalButton() {

    console.log("scheduleIntervalButton()");

    console.log(this.ngModelObjectDivision[4][0].keyValue);

    let dialogRef = this.dialog.open(CronJobIntervalComponent, {
      maxWidth: '100vw',
      width: "90%",
      data: {},
      disableClose: true
    });

    // subcribe the popup after close
    dialogRef.afterClosed().subscribe(result => {

      console.log(result);

      console.log(this.ngModelObjectDivision);

      if(this.ngModelObjectDivision[4][0].keyName == "scheduleinterval") {
        this.ngModelObjectDivision[4][0].keyValue = result.data;
        console.log(this.ngModelObjectDivision[4].keyValue);
      }


    });

  }

  disableFields(headerNameHtml,formName){

   // console.log(headerNameHtml,formName,this.data.buttonName,this.externalObjectFileName,this.readonlyObjectName)
  //  console.log( this.externalObjectFileName)

    if(this.data.buttonName == "Update"){
      if(headerNameHtml == "Manage Workspace" && (formName == "Company" || formName == "Workspace Name")){
        return true;
      }
      else if(headerNameHtml == "Objects" && ( formName =="Object Name")&& (this.externalObjectFileName ==true || this.readonlyObjectName ==true)){
           return true;

      }
      /**
       * @ModifiedBy-Asha Waghadure
       * @Date-22-08-2025
       * @Note-to disable Action File Name and Input File Name
       */
      else if(headerNameHtml == "Manage Test Scripts" && ( formName =="Actions File Name" ||  formName =="Input File Name")){
           return true;

      }else{
  
        return false;
      }
    }else{
 // console.log(headerNameHtml);
 // console.log("**************************");
  
  
      if(headerNameHtml == "Objects" && (formName =="Object Name")&& this.externalObjectFileName ==true ){
        //console.log("0000000000000000000000000")
       return true;
      }
      /**
       * @ModifiedBy-Asha Waghadure
       * @Date-22-08-2025
       * @Note-to disable Action File Name and Input File Name
       */
      else if(headerNameHtml == "Manage Test Scripts" && ( formName =="Actions File Name" ||  formName =="Input File Name")){
           return true;

      }else{
       return false

        
      }

     
    }




  
   }



   onFileSelected(event) {
    console.log("=========;;;;;;;=========")
    let flag =true;
    if(this.data.buttonName == "Update" && event.target.files[0].name!=undefined){
      console.log("========================")
      for(let a=0;a<this.ngModelObject.length;a++){
         if(this.ngModelObject[a].keyName ==="objectname"){
          if((this.ngModelObject[a].keyValue+".csv").toLowerCase() !== (event.target.files[0].name).toLowerCase()){
            flag =false;
            this.snackbar.open("File name should be same as Object Name", "OK", { duration: 5000 } );
          }
        }
       }
    }

    

    console.log("=========;;;;;;;=========")

    if(flag){ 
    console.log(this.externalObjectFile)
   // console.log(this.externalObjectFile.type);
//console.log(this.externalObjectFile.name);
   // console.log(fileNameArr[fileNameArr.length-1]);

    //application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
    // text/csv
   // console.log(this.externalObjectFile.name.endsWith(".csv"));
   // console.log(this.externalObjectFile.name);
  if(event.target.files[0].type === "text/csv" && event.target.files[0].name.endsWith(".csv") ){
    this.externalObjectFile = event.target.files[0];
   // let fileNameArr = this.externalObjectFile.name.split(".");

   console.log("inside if block perform teh operation")
   this.externalObjectFileName=true;
   console.log(this.ngModelChildObjectDivision);
   console.log(this.ngModelChildObject)
   let filename = this.externalObjectFile.name.split(".");
   this.csvToJson(event);
   for(let a=0;a<this.ngModelObject.length;a++){
    if(this.ngModelObject[a].keyName ==="objectlabel"){
      this.ngModelObject[a].keyValue =filename[0];
      console.log(this.ngModelObject[a]);
    }else if(this.ngModelObject[a].keyName ==="objectname"){
      this.ngModelObject[a].keyValue = filename[0];
      console.log(this.ngModelObject[a]);
    }
   }
  console.log(this.dynamicData)
  console.log(this.ngModelObject)
//this.csvJSON();

  }else{
    this.snackbar.open("Invalid file. Please select Csv file", "OK", { duration: 5000 });
  }
  
    }
  }
  downloadTemplate(event) {
    if(this.buttonName === "Update"){
      let tenantId=localStorage.getItem('dnsName');
      let fileNAme;
      for(let a=0;a<this.ngModelObject.length;a++){
        if(this.ngModelObject[a].keyName ==="objectname"){
         fileNAme = this.ngModelObject[a].keyValue+".csv";
          
        }console.log(this.ngModelObject[a]);
       }

       console.log(fileNAme)



      this.service.downloadLibraryObject(tenantId, fileNAme).subscribe(x => {
        console.log(x);
        if(x.size==0){
          this.snackbar.open("File does not exist", "OK", { duration: 5000 });
      return
  
        }else{ 
       
          
        const isJsonBlob = (data) => data instanceof Blob && data.type === "application/json";
        const responseData = isJsonBlob(x)
        if (responseData){
          this.snackbar.open(this.constants.fileNotFound, "OK", {duration: 5000});

        }
        else{
          console.log(x)
          var newBlob = new Blob([x]);
        

          // For other browsers:
          // Create a link pointing to the ObjectURL containing the blob.
          const data = window.URL.createObjectURL(newBlob);
          console.log(data)

          var link = document.createElement('a');
          link.href = data;
          link.download = fileNAme;
          // this is necessary as link.click() does not work on the latest firefox
          link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
          setTimeout(function () {
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(data);
            link.remove();
          }, 100);

        }
      }
        
      })

      
    }else{ 

   // console.log(this.externalObjectFile)
    if(this.externalObjectFile === undefined){ 
      console.log(this.externalObjectFile);
      this.snackbar.open("File does not exist", "OK", { duration: 5000 });
      return
  
  }else{
    console.log(event);
    var newBlob = new Blob([this.externalObjectFile], { type: 'text/csv' });
  
    const data = window.URL.createObjectURL(newBlob);
    console.log(data)
    var link = document.createElement('a');
    link.href = data;
   // console.log(event.rowData.fileName)
    link.download = this.externalObjectFile.name;
    console.log("ento")
    // this is necessary as link.click() does not work on the latest firefox
    link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
    setTimeout(function () {
      // For Firefox it is necessary to delay revoking the ObjectURL
      window.URL.revokeObjectURL(data);
      link.remove();
    }, 100);

   
  }
}



}

clearFileSelection(): void {
 // this.externalObjectFileName=false;
 // this.externalObjectFile = undefined;
 const fileInput = document.getElementById('file-upload') as HTMLInputElement;
  if (fileInput) {
    fileInput.value = '';  // Reset the input value
  }


  for(let a=0;a<this.ngModelObject.length;a++){
    if(this.ngModelObject[a].keyName ==="objectlabel"){
      this.ngModelObject[a].keyValue ="";
      console.log(this.ngModelObject[a]);
    }else if(this.ngModelObject[a].keyName ==="objectname"){
      this.ngModelObject[a].keyValue ="";
      console.log(this.ngModelObject[a]);
    }else if(this.ngModelObject[a].keyName ==="objectattributes"){
      this.ngModelObject[a].keyValue ="";
      console.log(this.ngModelObject[a]);
    }
   }
  
   this.externalObjectFileName=false;
   this.externalObjectFile = undefined;
}




// public csvJSON(fileLoadedEvent) {

//   let json = this.convertCsvToJson.getJsonFromCsv(this.externalObjectFile);
//   console.log(json)
//   for(let i=0; i<json.length;i++){
//       console.log(json[i]);
//   }

// }

csvToJson(event){
  console.log("=====================11")
  const file = event.target.files[0];
  const reader = new FileReader();

  reader.readAsText(file);
  console.log("=====================1221")
  reader.onload = (event:any) =>{
    console.log(event);
    let binarydata = event.target.result;
    // let workbook = XLSX.read(binarydata,{type:'binary'})
    // console.log(workbook.SheetNames[1])
    // workbook.SheetNames.forEach(sheet =>{
      //console.log(sheet);
      // const jsonFromCsv = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]]);
      //console.log(this.attributeJsonFromFile);
      const rows = binarydata.split(/\r?\n/).filter(row => row.trim() !== '');
      const headers = rows[0].split(',').map(header => header.trim());
      const jsonFromCsv = rows.slice(1).map(row => {
        const values = row.split(',').map(value => value.trim());
        const obj: any = {};
        headers.forEach((header, index) => { 
          obj[header] = values[index] || ''; 
      })
      return obj;
      });
      let maxKeysObject;
      let maxKeysCount=0;
      jsonFromCsv.forEach(obj => {
        const keysCount = Object.keys(obj).length;
        if (keysCount > maxKeysCount) {
          maxKeysCount = keysCount;
          maxKeysObject = obj;
        }
      });

      
      console.log(maxKeysObject);
      let attributeArr =[];
      for (const key in maxKeysObject) {

        let template ={
          "name": key,
          "type": null,
          "label": key,
          "required": true,
          "type_value":null,
          "list_column": false,
          "max_type_value": null,
          "min_type_value": null,
          "isControlledVocabulary": null
        }
        attributeArr.push(template);
      }
      this.attributeJsonFromFile=attributeArr;

      for(let a=0;a<this.ngModelObject.length;a++){
        if(this.ngModelObject[a].keyName ==="objectattributes"){
          this.ngModelObject[a].keyValue =JSON.stringify(this.attributeJsonFromFile);
          console.log(this.ngModelObject[a]);
        }
       }
    // })
     
    
    // console.log(rows)
  }

  console.log("=====================1331")
}




   checkToShowSelectDropDown(ngModelTemporary,systemName,headerNameHtml){
    if(headerNameHtml == "Data Source Configuration"){
    if(ngModelTemporary.fieldName=='vaultversion' && systemName == 'Vault'){
      return true;
    }else if(ngModelTemporary.fieldName=='vaultversion' && systemName != 'Vault'){
      return false;
    }else if(ngModelTemporary.fieldName=='vaultauthtype'){
      return this.showAuthName;
    }else{
      return true
    }
  }else{
    return true
  }
   }
   openAttributePopup(ngModelTemporary){
    console.log(ngModelTemporary);
    console.log(this.ngModelObject);
    let dialogRef = this.dialog.open(CreateAttributesScreenComponent, {
                width: "80%",
                autoFocus: false,
                maxWidth: '100vw',
                height: "90%",
                disableClose: true,
                data: {existingAttributesData: ngModelTemporary.keyValue},
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        console.log(result);
        for(let a=0;a<this.ngModelObject.length;a++){
          if(this.ngModelObject[a].keyName ==="objectattributes"){
            this.ngModelObject[a].keyValue =result
            console.log(this.ngModelObject[a]);
          }
          }
      }
    });
    
   }
   /**
    * @Author-Asha W
    * @Date-12-12-2025
    * @note-added popup when click on Add Attibute of Mdl script of Manage Workspace screen
    */
    openMDLPopup(ngModelTemporary){
    console.log(ngModelTemporary);
    console.log(this.ngModelObject);
        var tenantid;

    for (let i=0; i<this.ngModelObject.length; i++) {
      if (this.ngModelObject[i].keyName === "vaultconfigmstridtarget") {
               tenantid = this.ngModelObject[i].keyValue;
              console.log(tenantid)
              break
      }
    }
     if (!tenantid || tenantid === 0) {
    this.snackbar.open("Please select Target.", "OK", { duration: 5000 });
    return; 
  }
    let dialogRef = this.dialog.open(MultiselectmdlscriptComponent, {
                width: "80%",
                autoFocus: false,
                maxWidth: '100vw',
                height: "90%",
                disableClose: true,
                data: {edata: ngModelTemporary.keyValue,tenantid:tenantid},
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        console.log(result);
        for(let a=0;a<this.ngModelObject.length;a++){
          if(this.ngModelObject[a].keyName ==="mdlscripts"){
            this.ngModelObject[a].keyValue =result
            console.log(this.ngModelObject[a]);
          }
          }
      }
    });
    
   }
   /**
    * @Author-Asha Waghadure
    * @Date-18-07-2025
    * @Note-added for managetestscriptsmstr to display Action File based on script type
    */
   
   displayActionFileBasedOnScriptType(isSelected: boolean): void {
          if (this.isSelected) {
             this.dynamicData.forEach(e => {
               if (e.fieldName === "featurefilepathpath") {
                    e.mandatory = false;
                    e.showForm = false;
                      if(this.buttonName !== "Update"){
                        const control = this.formValid.get(e.fieldName);
                        console.log(control)
                        if (control) {
                         control.clearValidators();
                         control.updateValueAndValidity();
                        }
                      }
               }
              if (e.fieldName === "featurefilepath") {
                e.showForm = false;
              }
              this.ngModelObject.forEach(e => {
              if (e.fieldName === "featurefilepathpath") {
                    e.mandatory = false;
                    e.showForm=false;
              }
              if (e.fieldName === "featurefilepath") {
                e.showForm=false;
                
                 if(this.buttonName !== "Update"){
                        const control = this.formValid.get(e.fieldName);
                        console.log(control)
                        if (control) {
                         control.clearValidators();
                         control.updateValueAndValidity();
                        }
                      }
              }

              });

            });
          }
          else{
                this.dynamicData.forEach(e => {
                if (e.fieldName === "featurefilepathpath") {
                   e.mandatory = true;
                   e.showForm = true;
                }
                if (e.fieldName === "featurefilepath") {
                 e.showForm = true;
                }
   
                this.ngModelObject.forEach(e => {
                 if (e.fieldName === "featurefilepathpath") {
                      e.mandatory = true;
                      e.showForm = true;
                 }
                if (e.fieldName === "featurefilepath") {
                e.showForm = true;
                      if(this.buttonName !== "Update"){
                         const control = this.formValid.get(e.fieldName);
                         if (control) {
                          control.setValidators(Validators.required);
                          control.setValidators(this.validation.noWhitespaceValidator)
                          control.updateValueAndValidity();
                         }
                      }
                }
                });
              });
            }
   }


    /**
    * @Author-Asha Waghadure
    * @Date-18-07-2025
    * @Note-added for managetestscriptsmstr to display default validation
    */
    displayAllFieldsManageTestScriptScreen(): void {
          this.dynamicData.forEach(e =>{
            if(e.fieldName ==="featurefilepathpath"){          
             e.mandatory = true;
             e.showForm=true;
            }
            if(e.fieldName ==="featurefilepath"){          
            e.showForm=true;
            }
            this.ngModelObject.forEach(e => {
            if (e.fieldName === "featurefilepathpath") {
             e.mandatory = true;
             e.showForm=true;
            }
            if (e.fieldName === "featurefilepath") {
             e.showForm=true;
            }
           });
         })
   }
   /**
    * @Author-Asha Waghadure
    * @Date-12-12-2025
    * @Note-added for tenantmanagementmstr to display default validation
    */
    displayAllFieldsBasedOnJtestWorkspace(): void {
          this.dynamicData.forEach(e =>{
            if(e.fieldName ==="migrationtype"){          
             e.mandatory = true;
             e.showForm=true;
            }
            if(e.fieldName ==="setsize"){          
            e.showForm=true;
            }
             if (e.fieldName === "databasename") {
                e.showForm = true;
              }
              if (e.fieldName === "bucketname") {
                e.showForm = true;
              }
              if (e.fieldName === "noofsets") {
                e.showForm = true;
              }
              if (e.fieldName === "deferredsets") {
                e.showForm = true;
              }
              if (e.fieldName === "secondarysource") {
                e.showForm = true;
              }
              if (e.fieldName === "secondarytarget") {
                e.showForm = true;
              }
            this.ngModelObject.forEach(e => {
            if (e.fieldName === "migrationtype") {
             e.mandatory = true;
             e.showForm=true;
              
            }
            if (e.fieldName === "setsize") {
             e.showForm=true;
            }
             if (e.fieldName === "databasename") {
                e.showForm = true;
              }
              if (e.fieldName === "bucketname") {
                e.showForm = true;
              }
              if (e.fieldName === "noofsets") {
                e.showForm = true;
              }
              if (e.fieldName === "deferredsets") {
                e.showForm = true;
              }
              if (e.fieldName === "secondarysource") {
                e.showForm = true;
              }
              if (e.fieldName === "secondarytarget") {
                e.showForm = true;
              }
           });
         })
   }
   /**
    * @Author-Asha Waghadure
    * @Date-12-12-2025
    * @Note-added for tenantmanagementmstr to display validation based on jtestworkspace
    */
   displayFieldsBasedOnJtestWorkspace(isSelected: boolean): void {
          if (isSelected) {
             this.dynamicData.forEach(e => {
               if (e.fieldName === "migrationtype") {
                    e.mandatory = false;
                    e.showForm = false;
                      if(this.buttonName !== "Update"){
                        const control = this.formValid.get(e.fieldName);
                        console.log(control)
                        if (control) {
                         control.clearValidators();
                         control.updateValueAndValidity();
                        }
                      }
               }
              if (e.fieldName === "setsize") {
                e.showForm = false;
              }
              if (e.fieldName === "databasename") {
                e.showForm = false;
              }
              if (e.fieldName === "bucketname") {
                e.showForm = false;
              }
              if (e.fieldName === "noofsets") {
                e.showForm = false;
              }
              if (e.fieldName === "deferredsets") {
                e.showForm = false;
              }
              if (e.fieldName === "secondarysource") {
                e.showForm = false;
              }
              if (e.fieldName === "secondarytarget") {
                e.showForm = false;
              }
               if (e.fieldName === "mdlscripts") {
                e.showForm = true;
                                e.mandatory = true;

              }
              this.ngModelObject.forEach(e => {
              if (e.fieldName === "setsize") {
                    e.showForm=false;
              }
               if (e.fieldName === "databasename") {
                e.showForm = false;
              }
              if (e.fieldName === "bucketname") {
                e.showForm = false;
              }
              if (e.fieldName === "noofsets") {
                e.showForm = false;
              }
              if (e.fieldName === "deferredsets") {
                e.showForm = false;
              }
              if (e.fieldName === "secondarysource") {
                e.showForm = false;
              }
              if (e.fieldName === "secondarytarget") {
                e.showForm = false;
              }
               if (e.fieldName === "mdlscripts") {
                e.showForm = true;
                e.mandatory = true;

              }
              if (e.fieldName === "migrationtype") {
                e.showForm=false;
                e.mandatory = false;

                  const shouldSetRequired =
                  this.buttonName !== "Update" ||
                  (this.buttonName === "Update" && isSelected ==true);

                  if (shouldSetRequired && this.formValid) {
                  const control = this.formValid.get(e.fieldName);
                   if (control) {
                   control.clearValidators();
                   control.updateValueAndValidity({ emitEvent: false });
                   }
                  }
              }

              });

            });
          }
          else{
                this.dynamicData.forEach(e => {
                if (e.fieldName === "migrationtype") {
                   e.mandatory = true;
                   e.showForm = true;
  
                }
                if (e.fieldName === "setsize") {
                 e.showForm = true;
                }
                if (e.fieldName === "databasename") {
                e.showForm = true;
              }
              if (e.fieldName === "bucketname") {
                e.showForm = true;
              }
              if (e.fieldName === "noofsets") {
                e.showForm = true;
              }
              if (e.fieldName === "deferredsets") {
                e.showForm = true;
              }
              if (e.fieldName === "secondarysource") {
                e.showForm = true;
              }
              if (e.fieldName === "secondarytarget") {
                e.showForm = true;
              }
              if (e.fieldName === "mdlscripts") {
                e.showForm = false;
                                e.mandatory = false;

              }
   
                this.ngModelObject.forEach(e => {
                 if (e.fieldName === "setsize") {
                      e.showForm = true;
                 }
                  if (e.fieldName === "databasename") {
                e.showForm = true;
              }
              if (e.fieldName === "bucketname") {
                e.showForm = true;
              }
              if (e.fieldName === "noofsets") {
                e.showForm = true;
              }
              if (e.fieldName === "deferredsets") {
                e.showForm = true;
              }
              if (e.fieldName === "secondarysource") {
                e.showForm = true;
              }
              if (e.fieldName === "secondarytarget") {
                e.showForm = true;
              }
              if (e.fieldName === "mdlscripts") {
                e.showForm = false;
                e.mandatory = false;
                 const control = this.formValid?.get(e.fieldName);
                if (control) {
                 control.clearValidators();
                 control.updateValueAndValidity({ emitEvent: false });
                }

              }
                if (e.fieldName === "migrationtype") {
                e.showForm = true;
                e.mandatory = true;
                


                    const shouldSetRequired =
                  this.buttonName !== "Update" ||
                  (this.buttonName === "Update" && isSelected != null && !isSelected);

                  if (shouldSetRequired && this.formValid) {
                  const control = this.formValid.get(e.fieldName);
                   if (control) {
                   control.clearValidators();
                   control.setValidators([Validators.required]);
                   control.updateValueAndValidity({ emitEvent: false });
                   control.markAsDirty();
                   }
                  }

                   
               }
                });
              });
            }
   }

    applyEmailUsernameLogic() {
     const usernameCtrl = this.formValid.get('username');
     const emailAsUsernameCtrl = this.formValid.get('emailasusername');
     const userEmailCtrl = this.formValid.get('useremail');

      // When checkbox value changes
      emailAsUsernameCtrl?.valueChanges.subscribe((checked: boolean) => {
       if (checked) {
        // Set email = username
          userEmailCtrl?.setValue(usernameCtrl?.value);

        // Remove validators
          userEmailCtrl?.clearValidators();
          userEmailCtrl?.updateValueAndValidity();

        // Optional: disable email field
        // userEmailCtrl?.disable();
       } else {
      // Checkbox unchecked → clear the email field
        userEmailCtrl?.setValue('');

      // Re-enable field
       userEmailCtrl?.enable();

      // Apply required + email validators
        userEmailCtrl?.setValidators([Validators.required, Validators.email]);
        userEmailCtrl?.updateValueAndValidity();
      }
    });

  // If username changes while checkbox is checked
      usernameCtrl?.valueChanges.subscribe(val => {
      if (emailAsUsernameCtrl?.value) {
        userEmailCtrl?.setValue(val);
     }
    });
  }

  /**
   * @Author Shyam
   * @Date 30/01/2026
   * @param isMandatory 
   * @description method used to set the column as mandatory based on which are dependent on another column value
   */
  setAuthNameMandatory(isMandatory: boolean) {
  const authControl = this.formValid.get('vaultauthtype');

  if (isMandatory) {
    authControl?.setValidators([Validators.required]);
  } else {
    authControl?.clearValidators();
    authControl?.reset();
  }

  authControl?.updateValueAndValidity();
}

// Method triggered when user changes Section dropdown
/**
 * Author: Sujeet Kumar
 * Date: 09-02-2026
 * Description:
 * - Updates selected section
 * - Filters fields based on selected page layout + section
 * - Clears previously selected field to avoid mismatch
 */

onSectionChange(selectedSection: string, ngModelTemporary: any) {
  this.selectedSection = selectedSection;
  
  if (this.selectedPageLayout && selectedSection) {
    const attributes = this.layoutAttributeMap.get(this.selectedPageLayout.layoutLabelName) || [];
    
    const fields = attributes
      .filter(attr => attr.section_name === selectedSection)
      .map(attr => attr.fieldlabel)
      .filter(label => label && label.trim().length > 0);

    this.availableFields = [...new Set(fields)].filter(field => field); 
    
    const fieldField = this.ngModelObject.find(f => 
      f.fieldName?.toLowerCase().includes('field')
    );
    if (fieldField) fieldField.keyValue = '';
    
    this.cdr.detectChanges();
  }
}

// Triggered when Repository Type (Standard / Custom) changes
/**
 * Author: Sujeet Kumar
 * Date: 09-02-2026
 * Description:
 * - Stores selected repository type
 * - Resets page/section/field for Custom
 * - Loads page layouts for Standard
 */
onRepositoryTypeChange(type: 'Custom' | 'Custom') {
  this.repositoryType = type;
  
  if (type === 'Custom') {
    this.resetToCustomMode();
  } else {
    this.loadPageLayoutsForDropdowns();
  }
}


// Resets page layout dependent fields for Custom repository
/**
 * Author: Sujeet Kumar
 * Date: 09-02-2026
 * Description:
 * - Clears selected page layout
 * - Clears section and field dropdowns
 * - Resets page, section and field values in form model
 */
resetToCustomMode() {
  this.selectedPageLayout = null;
  this.availableSections = [];
  this.availableFields = [];

  const pageField = this.ngModelObject.find(f => 
    f.fieldName?.toLowerCase().includes('page')
  );
  const sectionField = this.ngModelObject.find(f => 
    f.fieldName?.toLowerCase().includes('section')
  );
  const fieldField = this.ngModelObject.find(f => 
    f.fieldName?.toLowerCase().includes('field')
  );
  
  if (pageField) pageField.keyValue = '';
  if (sectionField) sectionField.keyValue = '';
  if (fieldField) fieldField.keyValue = '';
}


// Populate section and field dropdowns during Edit
/**
 * Author: Sujeet Kumar
 * Date: 09-02-2026
 * Description:
 * - Used during Update flow
 * - Loads sections and fields based on existing page layout
 * - Prevents auto-selection when page layout is changed
 * - Avoids incorrect section/field binding
 */
populateSectionAndFieldForEdit() {
  const pageField = this.ngModelObject.find(f =>
    f.fieldName?.toLowerCase().includes('page')
  );
  const sectionField = this.ngModelObject.find(f =>
    f.fieldName?.toLowerCase().includes('section')
  );
  const fieldField = this.ngModelObject.find(f =>
    f.fieldName?.toLowerCase().includes('field')
  );

  // If page field is empty, do nothing
  if (!pageField || !pageField.keyValue) return;

  this.selectedPageLayout = this.pageLayoutList.find(
    l => l.layoutLabelName === pageField.keyValue
  );

  if (!this.selectedPageLayout) return;

  const attributes =
    this.layoutAttributeMap.get(this.selectedPageLayout.layoutLabelName) || [];

  this.availableSections = [
    ...new Set(attributes.map(a => a.section_name).filter(Boolean))
  ];

  // CRITICAL FIX: Don't auto-select section even if value exists in new layout
  // Instead, check if this is the SAME page layout as before
  const isSamePageLayout = (this.data.buttonName === 'Update' && 
                          pageField.keyValue === pageField.originalValue);
  
  if (isSamePageLayout && sectionField?.keyValue) {
    // Only auto-select if it's the SAME page layout during edit
    this.selectedSection = sectionField.keyValue;
    
    const fields = attributes
      .filter(a => a.section_name === sectionField.keyValue)
      .map(a => a.fieldlabel)
      .filter(v => v && v.trim().length > 0);

    this.availableFields = [...new Set(fields)];
  } else {
    // If page layout changed OR it's a new record, clear section
    if (sectionField) {
      sectionField.keyValue = '';
      const sectionControl = this.formValid.get(sectionField.fieldName);
      if (sectionControl) sectionControl.setValue('');
    }
    
    if (fieldField) {
      fieldField.keyValue = '';
      const fieldControl = this.formValid.get(fieldField.fieldName);
      if (fieldControl) fieldControl.setValue('');
    }
    
    this.availableFields = [];
    this.selectedSection = '';
  }

  this.cdr.detectChanges();
}
loadPageLayoutsForDropdowns() {
  // If pageLayoutList is empty but data has pageLayouts, use them
  if (this.pageLayoutList.length === 0 && this.data.pageLayouts) {
    this.pageLayoutList = this.data.pageLayouts;
  }
  
  // If layoutAttributeMap is empty but data has it, use it
  if (this.layoutAttributeMap.size === 0 && this.data.layoutAttributeMap) {
    this.layoutAttributeMap = this.data.layoutAttributeMap;
  }
  
  console.log('Loaded page layouts:', this.pageLayoutList);
  console.log('Loaded layout attribute map:', this.layoutAttributeMap);
}


syncRepositoryTypeToNgModel() {
  const repoObj = this.ngModelObject.find(o => o.keyName === 'repository_type');
  if (!repoObj) return;

  const dropdown = this.listObjectDropDown[repoObj.dropDownIndex];
  if (!dropdown) return;

  const match = dropdown.find(
    (d: any) => d.lookupvalue === this.repositoryType
  );

  if (match) {
    repoObj.keyValue = match.lookupvalueid; // ✅ NUMBER
  }
}


loadPageLayouts() {
  this.spinner.start();

  this.service.getObjectPageLayouts().subscribe({
    next: (response: any) => {
      this.spinner.stop();

      this.pageLayoutList = response?.data || response || [];

      this.layoutAttributeMap.clear();

      this.pageLayoutList.forEach((layout: any) => {
        if (layout.layoutAttributes && layout.layoutLabelName) {
          try {
            const attributes = JSON.parse(layout.layoutAttributes);
            this.layoutAttributeMap.set(layout.layoutLabelName, attributes);
          } catch (e) {
            console.error('Error parsing layoutAttributes', e);
          }
        }
      });

      this.cdr.detectChanges();
      this.populateSectionAndFieldForEdit();

    },
    error: () => this.spinner.stop()
  });
}

// Triggered when Page Layout dropdown changes
/**
 * Author: Sujeet Kumar
 * Date: 09-02-2026
 * Description:
 * - Resets section and field when page layout changes
 * - Reloads sections based on selected layout
 * - Clears invalid form validations
 */

onPageLayoutChange(selectedLayoutName: string, ngModelTemporary: any) {
  // Use your working method
  this.selectedPageLayout = this.pageLayoutList.find(
    l => l.layoutLabelName === selectedLayoutName
  );

  const pageControl = this.formValid.get(ngModelTemporary.fieldName);
  if (pageControl) {
    pageControl.clearValidators(); 
    pageControl.setValue(selectedLayoutName);
    pageControl.markAsDirty();
    pageControl.markAsTouched();
    pageControl.setErrors(null);
    pageControl.updateValueAndValidity();
  }

  const sectionField = this.ngModelObject.find(f => 
    f.fieldName?.toLowerCase().includes('section')
  );
  const fieldField = this.ngModelObject.find(f => 
    f.fieldName?.toLowerCase().includes('field')
  );
  
  if (sectionField) {
    sectionField.keyValue = '';
    const sectionControl = this.formValid.get(sectionField.fieldName);
    if (sectionControl) sectionControl.setValue('');
  }
  
  if (fieldField) {
    fieldField.keyValue = '';
    const fieldControl = this.formValid.get(fieldField.fieldName);
    if (fieldControl) fieldControl.setValue('');
  }
  if (this.selectedPageLayout) {
    const attributes =
      this.layoutAttributeMap.get(this.selectedPageLayout.layoutLabelName) || [];

    this.availableSections = [
      ...new Set(attributes.map(a => a.section_name).filter(Boolean))
    ];

    this.availableFields = [];
    this.selectedSection = '';
    
  }

  this.cdr.detectChanges();
}

// Add this method to check if dropdown should be enabled
isPageLayoutDropdownReady(): boolean {
    return this.repositoryType === 'Standard' && 
           this.pageLayoutList && 
           this.pageLayoutList.length > 0;
}


setDefaultRepositoryTypeStandard() {
  if (this.headerNameHtml !== 'Screen Element Repository') return;
  
  const repoField = this.ngModelObject.find(
    o => o.fieldName === 'repository_type'
  );

  if (!repoField) return;

  const dropdownList = this.listObjectDropDown[repoField.dropDownIndex];
  if (!dropdownList || dropdownList.length === 0) return;

  // Find STANDARD option
  const standardOption = dropdownList.find(
    (item: any) => item.lookupvalue === 'Standard'
  );

  if (standardOption) {
    // Set the lookupvalueid as keyValue
    repoField.keyValue = standardOption.lookupvalueid;
    this.repositoryType = 'Standard';
  }
}
// Add this method in the component class
initializeRepositoryTypeForEdit() {
  if (this.headerNameHtml !== 'Screen Element Repository') return;
  
  console.log('Initializing repository type...');
  console.log('Button Name:', this.data.buttonName);
  console.log('Full ngModelObject:', this.ngModelObject);
  
  // Find the repository_type field
  const repoField = this.ngModelObject.find(o => 
    o.keyName === 'repository_type' || o.fieldName === 'repository_type'
  );
  
  if (!repoField) {
    console.error('Repository type field not found in ngModelObject');
    return;
  }
  
  console.log('Repository field found:', repoField);
  console.log('Repository keyValue:', repoField.keyValue, 'Type:', typeof repoField.keyValue);
  
  if (!repoField.keyValue && repoField.keyValue !== 0) {
    console.log('No repository type value found');
    return;
  }
  
  // Get dropdown options
  const dropdownOptions = this.listObjectDropDown[repoField.dropDownIndex];
  console.log('Dropdown options:', dropdownOptions);
  
  if (!dropdownOptions || dropdownOptions.length === 0) {
    console.warn('No dropdown options available');
    return;
  }
  
  // Try to find the matching option
  let selectedOption;
  const keyValueNum = Number(repoField.keyValue);
  
  // Try by lookupvalueid first
  selectedOption = dropdownOptions.find(
    (option: any) => option.lookupvalueid === keyValueNum
  );
  
  // If not found, try by lookupvalue (display text)
  if (!selectedOption) {
    selectedOption = dropdownOptions.find(
      (option: any) => option.lookupvalue === repoField.keyValue
    );
  }
  
  // If still not found, try to match the value property
  if (!selectedOption && repoField.value) {
    selectedOption = dropdownOptions.find(
      (option: any) => option.lookupvalue === repoField.value
    );
  }
  
  if (selectedOption) {
    this.repositoryType = selectedOption.lookupvalue as 'Custom' | 'Standard';
    console.log('Repository type successfully set to:', this.repositoryType);
    
    // If it's STANDARD, load the page layouts
    if (this.repositoryType === 'Standard') {
      this.loadPageLayouts();
    }
  } else {
    console.error('Could not find repository type in dropdown options', {
      keyValue: repoField.keyValue,
      keyValueNum,
      value: repoField.value,
      dropdownOptions: dropdownOptions.map(opt => ({
        lookupvalueid: opt.lookupvalueid,
        lookupvalue: opt.lookupvalue
      }))
    });
  }
}

}


